/* cotizador-engine.js — motor unico del cotizador de La Tinta.
 *
 * Fuente de verdad del catalogo de papeles, las tablas de precio, los tamanos
 * sugeridos, los algoritmos de optimizacion de rollo y el parser de texto libre.
 *
 * Por que existe: habia 10 secciones de cotizador con el motor copiado, y las
 * tablas ya se habian desincronizado (4 versiones de PRICES_60, 7 del catalogo
 * de papeles). Cualquier cambio de precio o de regla de negocio se hace AQUI y
 * lo ven todas las paginas: /products/cotizador y cada pagina de papel.
 *
 * No toca el DOM. La interfaz vive en cada seccion que lo consume.
 */
(function (global) {
  'use strict';

  var TABLE_MIN = 20, TABLE_MAX = 100, TABLE_STEP = 5;
  var MIN60_NORMAL = 40, MIN60_CHICO = 20;

  // El tope de piezas de una misma medida. Un pedido de 6000 laminas de 10x15
  // son 90 metros de rollo: mas que eso deja de ser una compra por la web.
  var MAX_QTY = 6000;

  // Estado del motor. No se toca de fuera con asignaciones: para eso estan
  // setMin60 y setForcedRoll, porque una asignacion desde otro archivo no
  // llegaria a esta variable.
  var _min60 = MIN60_NORMAL;
  var _forcedRoll = null;
  // GODMODE (uso interno): sin lado minimo de 10 cm ni minimo de rollo. Vive en
  // la sesion de la pestana para que lo vean todos los cotizadores y Mi pedido.
  var _god = false;
  try { _god = sessionStorage.getItem('lt-god') === '1'; } catch (e) {}
  function ladoMin() { return _god ? 0 : 10; }
  function setGod(v) {
    _god = !!v; _packCache = {}; _packOrden = []; _sugCache = {};
    try { if (_god) sessionStorage.setItem('lt-god', '1'); else sessionStorage.removeItem('lt-god'); } catch (e) {}
  }
  var _packCache = {}, _packOrden = [];

  // ── Cortes por trabajo, no por reloj (25-oct-2026) ──
  // Las busquedas largas se cortaban a los 80/240/250/50 ms, asi que el mismo
  // pedido daba otro acomodo segun la velocidad del equipo: el de 330 piezas
  // salia $949.990, $954.490 o $974.990. El Apps Script que cobra recalcula con
  // este motor en otro equipo, y el cliente podia pagar otro precio que el que
  // vio. Ahora se cuentan unidades de trabajo (comparaciones entre rectangulos
  // libres, combinaciones probadas) con topes fijos, calibrados para que un
  // computador normal haga el mismo trabajo que antes en esos milisegundos.
  // Mismo pedido, mismo precio, en cualquier equipo. Un celular lento tarda
  // mas en los pedidos grandes, en vez de cortar antes.
  var _trabajo = 0;
  var TOPE_BRUTA = 10000000;        // ~250 ms de packBrutaPorPieza en un PC
  var TOPE_PARTICIONES = 2000000;   // enumerar anchos de columna (~80 ms)
  var TOPE_BUSQUEDA = 5000000;      // combinar secciones de columnas (~240 ms)
  var TRABAJO_REPASO = 300000;      // packLocalSearch: piezas x vueltas

var PAPERS = [
  { id:'fs-smooth',    tab:'Smooth',       name:'Felix Schoeller Smooth',        weight:'200grs', finish:'mate',                    r60:0,    r110:0,    desc:'Ideal para fotografía y arte digital. Colores vibrantes con negros profundos.', line:'esencial', rec:true },
  { id:'fs-satin',     tab:'Satin',        name:'Felix Schoeller Satin',          weight:'240grs', finish:'semi brillo satinado',    r60:1,    r110:1,    desc:'Balance perfecto entre brillo y nitidez. Para retratos, moda y bodas.', line:'esencial' },
  { id:'hn-luster',    tab:'Photo Luster', name:'Hahnemühle Photo Luster',        weight:'260grs', finish:'semi brillante',          r60:2,    r110:2,    desc:'Alta definición con reflexión suave. El favorito de los fotógrafos profesionales.', line:'esencial' },
  { id:'fs-canvas',    tab:'Canvas',       name:'Felix Schoeller Canvas',         weight:'340grs', finish:'mate texturizado (lienzo)',r60:6,    r110:6,     desc:'Superficie texturizada tipo lienzo. Da un aspecto de pintura a fotografías y reproducciones de arte.', line:'esencial', alt:true },
  { id:'c-photogloss', tab:'Photogloss',   name:'Canson Photogloss Premium RC',   weight:'270grs', finish:'brillante (glossy)',       r60:null, r110:3,    desc:'Máximo brillo y saturación. Para impacto visual en piezas comerciales.', line:'esencial', alt:true },
  { id:'c-etching',    tab:'Etching Rag',  name:'Canson Edition Etching Rag',     weight:'310grs', finish:'mate grano fino (algodón)',r60:3,    r110:4,    desc:'Textura de algodón, aspecto galería. Para arte fino e ilustración.', line:'museo', rec:true },
  { id:'fs-watercolor',tab:'Watercolor',   name:'Felix Schoeller Watercolor Rag', weight:'310grs', finish:'texturado mate (algodón)', r60:5,   r110:null,  desc:'Superficie texturada para pinturas y reproducciones de arte en acuarela.', line:'museo' },
  { id:'fs-baryta',    tab:'Baryta',       name:'Felix Schoeller Baryta',         weight:'310grs', finish:'baritado',                r60:4,    r110:5,    desc:'Acabado fotográfico clásico. Blanco y negro impecable con rango tonal superior.', line:'museo' }
];

// Lengths 20→100cm step 5 (17 entries);

// Lengths 20→100cm step 5 (17 entries)
var PRICES_60 = [
  [9990,11490,12990,14490,16490,17990,19490,20990,22490,24490,25990,27490,28990,30990,32490,33990,35490],
  [9990,11490,13490,14990,16490,18490,19990,21490,23490,24990,26490,28490,29990,31490,32990,34990,36490],
  [10490,12490,14490,15990,17990,19490,21490,22990,24990,26990,28490,30490,31990,33990,35990,37490,39490],
  [14990,17990,20490,22990,25990,28490,30990,33990,36490,39490,41990,44490,47490,49990,52490,55490,57990],
  [12990,15490,17490,19990,21990,24490,26490,28990,30990,33490,35490,37990,39990,42490,44490,46990,48990],
  [12990,15490,17490,19990,21990,24490,26490,28990,30990,33490,35490,37990,39990,42490,44990,46990,49490],
  [11490,12990,14990,16990,18990,20990,22490,24490,26490,28490,30490,32490,33990,35990,37990,39990,41990]
];

var PRICES_110 = [
  [15990,18990,21490,24490,27490,30490,32990,35990,38990,41490,44490,47490,50490,52990,55990,58990,61490],
  [16490,19490,22490,24990,27990,30990,33990,36990,39990,42990,45490,48490,51490,54490,57490,60490,63490],
  [17490,20990,23990,27490,30490,33490,36990,39990,42990,46490,49490,52990,55990,58990,62490,65490,68490],
  [19490,22990,26490,29990,33490,36990,40490,43990,47490,50990,54990,58490,61990,65490,68990,72490,75990],
  [24990,29990,34490,38990,43990,48490,52990,57990,62490,66990,71990,76490,80990,85990,90490,95990,99990],
  [21990,25990,29990,33990,37990,41990,45990,49990,53990,57990,62490,66490,70490,74490,78490,82490,86490],
  [18990,22490,25490,28990,32490,35990,39490,42990,45990,49490,52990,56490,59990,63490,66990,69990,73490]
];

var SIZES = [
  {id:'a4',  label:'A4',          w:21,   h:29.7,  minQty:4, pop:true,  group:'din'},
  {id:'a3',  label:'A3',          w:29.7, h:42,    minQty:2, pop:true,  group:'din'},
  {id:'a3p', label:'A3+',         w:32.9, h:48.3,  minQty:1, pop:true,  group:'din'},
  {id:'a2',  label:'A2',          w:42,   h:59.4,  minQty:1, pop:true,  group:'din'},
  {id:'a1',  label:'A1',          w:59.4, h:84.1,  minQty:1, pop:false, group:'din'},
  {id:'a0',  label:'A0',          w:84.1, h:118.9, minQty:1, pop:false, group:'din'},
  {id:'20x30',  label:'20×30 cm', w:20,  h:30,  minQty:4, pop:false, group:'foto'},
  {id:'30x40',  label:'30×40 cm', w:30,  h:40,  minQty:2, pop:true,  group:'foto'},
  {id:'30x45',  label:'30×45 cm', w:30,  h:45,  minQty:2, pop:false, group:'foto'},
  {id:'40x50',  label:'40×50 cm', w:40,  h:50,  minQty:1, pop:true,  group:'foto'},
  {id:'20x25',  label:'20×25 cm', w:20,  h:25,  minQty:3, pop:true,  group:'foto'},
  {id:'60x60',  label:'60×60 cm', w:60,  h:60,  minQty:1, pop:false, group:'foto'},
  {id:'50x40',  label:'50×40 cm', w:50,  h:40,  minQty:1, pop:false, group:'foto'},
  {id:'60x40',  label:'60×40 cm', w:60,  h:40,  minQty:1, pop:true,  group:'foto'},
  {id:'50x70',  label:'50×70 cm', w:50,  h:70,  minQty:1, pop:true,  group:'foto'},
  {id:'60x80',  label:'60×80 cm', w:60,  h:80,  minQty:1, pop:false, group:'foto'},
  {id:'60x90',  label:'60×90 cm', w:60,  h:90,  minQty:1, pop:true,  group:'foto'},
  {id:'70x100', label:'70×100 cm',w:70,  h:100, minQty:1, pop:false, group:'foto'},
  {id:'80x100', label:'80×100 cm',w:80,  h:100, minQty:1, pop:false, group:'grande'},
  {id:'80x120', label:'80×120 cm',w:80,  h:120, minQty:1, pop:false, group:'grande'},
  {id:'90x120', label:'90×120 cm',w:90,  h:120, minQty:1, pop:false, group:'grande'},
  {id:'100x140',label:'100×140 cm',w:100,h:140, minQty:1, pop:false, group:'grande'},
  {id:'30x110', label:'30×110 cm',w:30,  h:110, minQty:1, pop:false, group:'pano'},
  {id:'35x110', label:'35×110 cm',w:35,  h:110, minQty:1, pop:false, group:'pano'},
  {id:'40x110', label:'40×110 cm',w:40,  h:110, minQty:1, pop:false, group:'pano'},
  {id:'40x120', label:'40×120 cm',w:40,  h:120, minQty:1, pop:false, group:'pano'},
  {id:'60x100', label:'60×100 cm',w:60,  h:100, minQty:1, pop:false, group:'pano'},
  {id:'60x120', label:'60×120 cm',w:60,  h:120, minQty:1, pop:true,  group:'pano'},
  {id:'50x150', label:'50×150 cm',w:50,  h:150, minQty:1, pop:false, group:'pano'},
  {id:'60x180', label:'60×180 cm',w:60,  h:180, minQty:1, pop:true,  group:'pano'},
  {id:'80x200', label:'80×200 cm',w:80,  h:200, minQty:1, pop:false, group:'pano'},
  {id:'100x200',label:'100×200 cm',w:100,h:200, minQty:1, pop:false, group:'pano'}
];

var PAPER_NLP = [
  { id: 'fs-watercolor', kw: ['watercolor','watercolour','aquarela','acuarela','fine art mate'] },
  { id: 'fs-canvas',     kw: ['canvas','tela','lienzo','bastidor'] },
  { id: 'c-etching',     kw: ['etching','rag','algodon','cotton','grano fino','fine art','hilo','fibra'] },
  { id: 'fs-baryta',     kw: ['baryta','baritado','bario','barytha','barita'] },
  { id: 'c-photogloss',  kw: ['brillante','glossy','gloss','photogloss','brilloso'] },
  { id: 'hn-luster',     kw: ['luster','lustre','photo luster','hahnemuhle','semi brillante'] },
  { id: 'fs-satin',      kw: ['satin','satinado','semi brillo','semibrillo'] },
  { id: 'fs-smooth',     kw: ['mate','matte','smooth'] }
];

// Los nombres de papel, para reconocerlos pegados a un numero.;

// Las palabras de papel, de la mas larga a la mas corta. El orden importa:
// "semi brillante" tiene que ganarle a "brillante", que es otro papel.
var PAPEL_CLAVES = (function() {
  var out = [];
  for (var i = 0; i < PAPER_NLP.length; i++) {
    for (var j = 0; j < PAPER_NLP[i].kw.length; j++) {
      var kw = stripAccents(PAPER_NLP[i].kw[j]);
      out.push({ id: PAPER_NLP[i].id, kw: kw,
                 re: new RegExp('\\b' + kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
                                's?\\b') });
    }
  }
  out.sort(function(a, b) { return b.kw.length - a.kw.length; });
  return out;
})();

// Cantidades que se escriben en palabras pero no son un numero suelto.
// Van con el resto porque se buscan igual, de la clave mas larga a la mas corta.
var WORD_NUMS = {
  'media docena':6,'medio ciento':50,'docena':12,'decena':10,'centenar':100,
  'par':2,'pareja':2,
  'un':1,'una':1,'dos':2,'tres':3,'cuatro':4,'cinco':5,'seis':6,'siete':7,
  'ocho':8,'nueve':9,'diez':10,'once':11,'doce':12,'trece':13,'catorce':14,
  'quince':15,'dieciseis':16,'diecisiete':17,'dieciocho':18,'diecinueve':19,
  'veinte':20,'veintiuno':21,'veintidos':22,'veinticinco':25,'treinta':30,
  'cuarenta':40,'cincuenta':50,'sesenta':60,'setenta':70,'ochenta':80,
  'noventa':90,'cien':100,'ciento':100,'doscientos':200,'quinientos':500
};

// ── Interpretacion del texto libre ──────────────────────────────────
// En un pedido de impresion cada numero es una de tres cosas: parte de una
// medida, una cantidad, o ruido (un folio, una fecha, un gramaje). En vez de
// escribir un patron por cada forma de escribirlo, se listan todos los numeros
// del segmento y se puntua que rol puede cumplir cada uno, usando los limites
// del negocio como guia. Gana el mejor candidato; si ninguno convence, se
// asume 1 pero se marca como supuesta, para poder avisarlo.
var NLP_CANT    = /(print|impresion|copia|unidad|uds?\b|u\b|pieza|hoja|foto|cuadro|lamina|ejemplar|c\/u|cantidad|cant\b|qty|veces)/;

var NLP_UNIDAD  = /^(\s*)(cm|mm|cms)\b/;

// Todos los numeros del texto, con lo que tienen alrededor.;

// Los nombres de papel, para reconocerlos pegados a un numero.
var NLP_PAPEL = new RegExp('^\\s*(' + PAPER_NLP.reduce(function(a, p) {
  return a.concat(p.kw);
}, []).sort(function(a, b) { return b.length - a.length; })
  .join('|').replace(/ /g, '\\s+') + ')\\b');

// Palabras que nombran una variante, no una cantidad.
// Dice que son varias sin decir cuantas: hay que preguntar, no asumir 1.;

var NLP_MES     = /(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|setiembre|octubre|noviembre|diciembre)/;

var NLP_RUIDO   = /(orden|pedido|folio|boleta|factura|n[\u00b0\u00ba]|#|ref|cotizacion|presupuesto)/;

var NLP_TECNICO = /^(\s*)(grs?\b|gsm|ppi|dpi|bits?\b|px\b|pixel|mp\b)/;

var NLP_CONTEXTO = /(version|vercion|archivo|diseno|opcion|alternativa|modelo|serie|prueba|muestra|capitulo|parte|tomo)\s*(n[o\u00ba\u00b0]?\.?\s*)?$/;

// Palabras que nombran una variante, no una cantidad.
// Dice que son varias sin decir cuantas: hay que preguntar, no asumir 1.
var NLP_VAGO = /\b(varias|varios|algunas|algunos|unas|unos|cuantas|cuantos|bastantes|muchas|muchos|pocas|pocos|suficientes|copias|impresiones|unidades|laminas|piezas|hojas|fotos|cuadros)\b/;

var NAMED_SIZES = {
  'a tres mas':{w:32.9,h:48.3}, 'a tres plus':{w:32.9,h:48.3},
  'a cero':{w:84.1,h:118.9}, 'a uno':{w:59.4,h:84.1},
  'a dos':{w:42,h:59.4},     'a tres':{w:29.7,h:42},
  'a cuatro':{w:21,h:29.7},  'a cinco':{w:14.8,h:21}, 'a seis':{w:10.5,h:14.8},
  'a0':{w:84.1,h:118.9}, 'a1':{w:59.4,h:84.1}, 'a2':{w:42,h:59.4},
  'a3+':{w:32.9,h:48.3}, 'a3 +':{w:32.9,h:48.3}, 'a3plus':{w:32.9,h:48.3}, 'a3 plus':{w:32.9,h:48.3},
  'a3':{w:29.7,h:42}, 'a4':{w:21,h:29.7}, 'a5':{w:14.8,h:21}, 'a6':{w:10.5,h:14.8},
  'letter':{w:21.6,h:27.9}, 'legal':{w:21.6,h:35.6},
  'carta':{w:21.59,h:27.94}, 'oficio':{w:21.59,h:33}
};

function interpolatePrice(priceTable, paperIdx, lengthCm) {
  var prices = priceTable[paperIdx];
  var L = Math.max(lengthCm, TABLE_MIN);
  if (L <= TABLE_MAX) {
    var frac = (L - TABLE_MIN) / TABLE_STEP;
    var lo = Math.floor(frac), hi = Math.ceil(frac);
    if (lo === hi) return { price: prices[lo], extrapolated: false };
    var t = frac - lo;
    return { price: Math.round(prices[lo] + t * (prices[hi] - prices[lo])), extrapolated: false };
  }
  var base = prices[prices.length - 1];
  return { price: Math.ceil(base * L / TABLE_MAX / 500) * 500 - 10, extrapolated: true };
}

// Single-item price estimate for Size step
function ptLengthForRoll(w, h, rollW) {
  var cW = w <= rollW, cH = h <= rollW;
  if (!cW && !cH) return null;
  if (cW && cH) return Math.min(w, h);
  return cW ? h : w;
}

function ptLengthForQty(w, h, rollW, qty) {
  var best = null;
  [[w,h],[h,w]].forEach(function(o) {
    var across = o[0], along = o[1];
    if (across > rollW) return;
    var ppr = Math.floor(rollW / across);
    var rows = Math.ceil(qty / ppr);
    var len = rows * along;
    if (best === null || len < best) best = len;
  });
  return best;
}

function ptPriceForSize(paperId, w, h, qty) {
  var paper = getPaper(paperId);
  if (!paper) return 0;
  qty = qty || 1;
  var best = null;
  function check(table, idx, rollW) {
    if (idx === null || idx === undefined) return;
    var minLen = rollW === 60 ? 40 : TABLE_MIN;
    var rawLen = qty === 1 ? ptLengthForRoll(w, h, rollW) : ptLengthForQty(w, h, rollW, qty);
    if (rawLen === null) return;
    var totalLen = Math.max(rawLen, minLen);
    var r = interpolatePrice(table, idx, totalLen);
    if (best === null || r.price < best) best = r.price;
  }
  check(PRICES_60, paper.r60, 60);
  check(PRICES_110, paper.r110, 110);
  return best || 0;
}

function preOptimizeRotations(items, rollWidth) {
  var result = [];
  for (var ii = 0; ii < items.length; ii++) {
    var item = items[ii];
    var w = item.w, h = item.h, qty = item.qty || 1;
    if (w === h || qty === 0) { result.push({ w: w, h: h, qty: qty, label: item.label, color: item.color, fits: true, originalW: w }); continue; }
    var natPerRow = Math.floor(rollWidth / w);
    var rotPerRow = Math.floor(rollWidth / h);
    if (natPerRow <= 0 && rotPerRow <= 0) { result.push({ w: w, h: h, qty: qty, label: item.label, color: item.color, fits: false, originalW: w }); continue; }
    if (natPerRow <= 0) { result.push({ w: h, h: w, qty: qty, label: item.label, color: item.color, fits: true, originalW: w }); continue; }
    if (rotPerRow <= 0) { result.push({ w: w, h: h, qty: qty, label: item.label, color: item.color, fits: true, originalW: w }); continue; }
    var bestTotal = Infinity, bestNRot = 0;
    for (var nRot = 0; nRot <= qty; nRot++) {
      var nNat = qty - nRot;
      var totalH = Math.ceil(nRot / rotPerRow) * w + Math.ceil(nNat / natPerRow) * h;
      if (totalH < bestTotal) { bestTotal = totalH; bestNRot = nRot; }
    }
    var bestNNat = qty - bestNRot;
    if (bestNRot > 0) result.push({ w: h, h: w, qty: bestNRot, label: item.label, color: item.color, fits: true, originalW: w });
    if (bestNNat > 0) result.push({ w: w, h: h, qty: bestNNat, label: item.label, color: item.color, fits: true, originalW: w });
  }
  return result;
}

function packShelfOnce(items, rollWidth, sortFn, newShelfPref) {
  var units = [];
  items.forEach(function(it) {
    for (var q = 0; q < it.qty; q++) units.push({ w: it.w, h: it.h, label: it.label, color: it.color });
  });
  if (sortFn) units.sort(sortFn);
  var shelves = [];
  var curShelf = null;
  units.forEach(function(u) {
    var placed = false;
    if (curShelf && !newShelfPref) {
      if (curShelf.x + u.w <= rollWidth) {
        curShelf.items.push({ x: curShelf.x, y: curShelf.y, w: u.w, h: u.h, label: u.label, color: u.color });
        curShelf.x += u.w;
        curShelf.h = Math.max(curShelf.h, u.h);
        placed = true;
      }
    }
    if (!placed) {
      var y = curShelf ? curShelf.y + curShelf.h : 0;
      curShelf = { x: u.w, y: y, h: u.h, items: [{ x: 0, y: y, w: u.w, h: u.h, label: u.label, color: u.color }] };
      shelves.push(curShelf);
    }
  });
  var totalLength = shelves.reduce(function(s, sh) { return s + sh.h; }, 0);
  return { shelves: shelves, totalLength: totalLength };
}

function _packMaxRectsOnce(oriented, rollWidth) {
  var rects = [{ x: 0, y: 0, w: rollWidth, h: 1e9 }];
  var placed = [];
  var units = [];
  oriented.forEach(function(it) {
    for (var q = 0; q < it.qty; q++) units.push({ w: it.w, h: it.h, label: it.label, color: it.color });
  });
  units.sort(function(a, b) { return (b.w * b.h) - (a.w * a.h); });

  units.forEach(function(u) {
    var best = null, bestScore = Infinity;
    rects.forEach(function(r) {
      if (u.w <= r.w && u.h <= r.h) {
        var score = r.y + u.h;
        if (score < bestScore) { bestScore = score; best = r; }
      }
    });
    if (!best) return;
    var px = best.x, py = best.y;
    placed.push({ x: px, y: py, w: u.w, h: u.h, label: u.label, color: u.color });
    // split rects
    var newRects = [];
    rects.forEach(function(r) {
      if (px + u.w <= r.x || px >= r.x + r.w || py + u.h <= r.y || py >= r.y + r.h) {
        newRects.push(r);
        return;
      }
      // top
      if (py > r.y) newRects.push({ x: r.x, y: r.y, w: r.w, h: py - r.y });
      // bottom
      if (py + u.h < r.y + r.h) newRects.push({ x: r.x, y: py + u.h, w: r.w, h: (r.y + r.h) - (py + u.h) });
      // left
      if (px > r.x) newRects.push({ x: r.x, y: py, w: px - r.x, h: u.h });
      // right
      if (px + u.w < r.x + r.w) newRects.push({ x: px + u.w, y: py, w: (r.x + r.w) - (px + u.w), h: u.h });
    });
    // prune dominated
    _trabajo += newRects.length * newRects.length;
    rects = newRects.filter(function(a) {
      return !newRects.some(function(b) {
        return b !== a && b.x <= a.x && b.y <= a.y && b.x + b.w >= a.x + a.w && b.y + b.h >= a.y + a.h;
      });
    });
  });

  if (!placed.length) return null;
  var totalLength = placed.reduce(function(mx, p) { return Math.max(mx, p.y + p.h); }, 0);
  return { shelves: placed, totalLength: totalLength, isMaxRects: true };
}

function packMaxRects(oriented, rollWidth) {
  var r1 = _packMaxRectsOnce(oriented, rollWidth);
  // also try rotated
  var rotated = oriented.map(function(it) {
    return { w: it.h <= rollWidth ? it.h : it.w, h: it.h <= rollWidth ? it.w : it.h, qty: it.qty, label: it.label, color: it.color };
  });
  var r2 = _packMaxRectsOnce(rotated, rollWidth);
  if (!r1 && !r2) return null;
  if (!r1) return r2;
  if (!r2) return r1;
  return r1.totalLength <= r2.totalLength ? r1 : r2;
}

function packShelfFixed(oriented, rollWidth) {
  var r1 = packShelfOnce(oriented, rollWidth, function(a, b) { return b.h - a.h || b.w - a.w; }, false);
  var r2 = packShelfOnce(oriented, rollWidth, function(a, b) { return b.w - a.w || b.h - a.h; }, false);
  var r3 = packShelfOnce(oriented, rollWidth, function(a, b) { return (b.w * b.h) - (a.w * a.h); }, false);
  var best = r1;
  if (r2.totalLength < best.totalLength) best = r2;
  if (r3.totalLength < best.totalLength) best = r3;
  return best;
}

function packBruteOrientations(items, rollWidth) {
  if (items.length > 8) return null; // too slow
  var best = null;
  function go(idx, current) {
    if (idx === current.length) {
      var r = packShelfFixed(current, rollWidth);
      if (!best || r.totalLength < best.totalLength) best = r;
      return;
    }
    var it = current[idx];
    // try original
    go(idx + 1, current);
    // try rotated (if different and fits)
    if (it.w !== it.h) {
      var alt = current.map(function(x, i) { return i === idx ? { w: x.h, h: x.w, qty: x.qty, label: x.label, color: x.color } : x; });
      if (alt[idx].w <= rollWidth) go(idx + 1, alt);
    }
  }
  var pre = preOptimizeRotations(items, rollWidth).filter(function(x) { return x.fits; });
  if (!pre.length) return null;
  go(0, pre);
  return best;
}

// Orientaciones pieza por pieza, traida del cotizador original.
// La de mas arriba gira grupos enteros de un mismo tamano; esta gira cada
// pieza por separado, asi que prueba 2^piezas arreglos en vez de 2^grupos.
// En un pedido de 9 piezas eso son 512 combinaciones contra 32, y por eso
// encuentra acomodos que la otra no ve. Se corta sola sobre 10 piezas, de
// modo que en pedidos grandes no cuesta nada.
//
// Conviven a proposito: cada una gana en casos distintos. packShelf se
// queda con la mejor de las dos, asi el resultado nunca empeora.
// MaxRects traido del cotizador original, para usar SOLO con piezas sueltas.
//
// Esta version coloca un rectangulo por entrada y da por hecho que quien la
// llama ya expandio las cantidades. Por eso no puede ser candidato de
// packShelf: ahi le llegan grupos con qty:5 y colocaria una sola pieza de
// cada uno, cotizando de menos. packBrutaPorPieza si expande antes, y con
// esa entrada acomoda mejor que el MaxRects propio en pedidos con piezas
// grandes: 5x(60x40) pasa de 160 a 120 cm en un rollo de 110.
function _mrSueltasOnce(oriented, rollWidth) {
    var LARGE = 999999;
    var free = [{x:0, y:0, w:rollWidth, h:LARGE}];
    var placed = [], maxY = 0;
    for (var i = 0; i < oriented.length; i++) {
      var it = oriented[i];
      if (it.w > rollWidth) return null;
      var bi = -1, bx = 0, by = LARGE, bss = Infinity;
      for (var j = 0; j < free.length; j++) {
        var f = free[j];
        if (f.w >= it.w && f.h >= it.h) {
          var ss = Math.min(f.w - it.w, f.h - it.h);
          if (f.y < by || (f.y === by && f.x < bx) || (f.y === by && f.x === bx && ss < bss)) {
            by = f.y; bx = f.x; bss = ss; bi = j;
          }
        }
      }
      if (bi < 0) return null;
      placed.push({x:bx, y:by, w:it.w, h:it.h, label:it.label, color:it.color, rotated:it.w!==it.originalW});
      maxY = Math.max(maxY, by + it.h);
      var nf = [];
      for (var j = 0; j < free.length; j++) {
        var f = free[j];
        if (bx >= f.x+f.w || bx+it.w <= f.x || by >= f.y+f.h || by+it.h <= f.y) {
          nf.push(f); continue;
        }
        if (bx > f.x)            nf.push({x:f.x,      y:f.y,    w:bx-f.x,           h:f.h});
        if (bx+it.w < f.x+f.w)  nf.push({x:bx+it.w,  y:f.y,    w:f.x+f.w-bx-it.w,  h:f.h});
        if (by > f.y)            nf.push({x:f.x,       y:f.y,    w:f.w,               h:by-f.y});
        if (by+it.h < f.y+f.h)  nf.push({x:f.x,       y:by+it.h, w:f.w,              h:f.y+f.h-by-it.h});
      }
      _trabajo += nf.length * nf.length;
      free = nf.filter(function(a, ai) {
        return !nf.some(function(b, bi) {
          return ai!==bi && b.x<=a.x && b.y<=a.y && b.x+b.w>=a.x+a.w && b.y+b.h>=a.y+a.h;
        });
      });
    }
    return {totalLength: Math.max(maxY, TABLE_MIN), shelves:[{y:0, height:maxY, usedWidth:rollWidth, placements:placed}]};
  }

function mrSueltas(oriented, rollWidth) {
    var sorters = [
      function(a,b){ return b.h-a.h || (b.w*b.h)-(a.w*a.h); },
      function(a,b){ return (b.w*b.h)-(a.w*a.h); },
      function(a,b){ return b.w-a.w; },
    ];
    var best = null;
    for (var si = 0; si < sorters.length; si++) {
      var r = _mrSueltasOnce(oriented.slice().sort(sorters[si]), rollWidth);
      if (r && (!best || r.totalLength < best.totalLength)) best = r;
    }
    return best;
  }

function packBrutaPorPieza(items, rollWidth) {
    var exp = [];
    items.forEach(function(it) {
      for (var q = 0; q < it.qty; q++) exp.push(it);
    });
    // Cada pieza extra duplica el trabajo: 2^n arreglos. El freno era la cantidad
    // de piezas, y sobre 14 la busqueda ni empezaba: los pedidos grandes se
    // quedaban con un acomodo peor y por lo tanto con un precio mas alto del que
    // corresponde. Un pedido de 21 piezas cotizaba 14,69 m de rollo cabiendo en
    // 11,34. Ahora hasta 14 se busca completo igual que siempre (cortar ahi
    // encarecia pedidos que antes salian bien) y de 15 para arriba se explora
    // hasta TOPE_BRUTA unidades de trabajo (antes: lo que alcanzara en 250 ms).
    // Cada combinacion suma ademas 5 por pieza: con pocas piezas por fila casi no
    // hay rectangulos que comparar, pero armar la combinacion igual cuesta.
    if (exp.length > 22) return null;   // 4 millones de arreglos: ni empezar
    var n = exp.length, best = null;

    // Giros por cantidad (25-oct-2026). Con 13 piezas iguales de 60x20 no importa
    // CUALES van giradas sino CUANTAS: 14 opciones en vez de 8192. Probar pieza por
    // pieza se comia el 95% del tiempo del cotizador (2,5 s un pedido de 14 piezas)
    // para llegar casi siempre al mismo acomodo. Se prueban todas las cantidades,
    // con las giradas primero y despues al final de su medida.
    function probar(oriented) {
      var r = packMaxRects(oriented, rollWidth);
      var rs = mrSueltas(oriented, rollWidth);
      if (rs && (!r || rs.totalLength < r.totalLength)) r = rs;
      if (r && (!best || r.totalLength < best.totalLength)) best = r;
    }
    function pieza(it, rot) {
      return Object.assign({}, it, { w: rot ? it.h : it.w, h: rot ? it.w : it.h, originalW: it.w, qty: 1 });
    }
    // Las filas de una misma medida se juntan, aunque esten escritas al reves
    // (50x30 y 30x50): son la misma pieza y girarla en una u otra fila da igual.
    var tipos = [], porClave = {};
    items.forEach(function(it) {
      if (!(it.qty > 0)) return;
      var clave = Math.min(it.w, it.h) + 'x' + Math.max(it.w, it.h), t = porClave[clave];
      if (!t) { t = porClave[clave] = { w: it.w, h: it.h, piezas: [] }; tipos.push(t); }
      for (var q = 0; q < it.qty; q++) t.piezas.push(it);
    });
    // La pieza p del tipo t, de pie (como el tipo) o acostada
    function orientada(t, p, acostada) {
      var deMedida = (p.w === t.w);           // la fila viene con la orientacion del tipo
      return pieza(p, deMedida ? acostada : !acostada);
    }
    var combos = 1;
    tipos.forEach(function(t) { if (t.w !== t.h) combos *= (t.piezas.length + 1); });
    if (combos <= 4000) {
      var giradas = tipos.map(function() { return 0; });
      for (var c = 0; c < combos; c++) {
        var resto = c, valida = true;
        for (var ti = 0; ti < tipos.length; ti++) {
          var tt = tipos[ti], Q = tt.piezas.length;
          if (tt.w === tt.h) { giradas[ti] = 0; continue; }
          giradas[ti] = resto % (Q + 1); resto = Math.floor(resto / (Q + 1));
          if (giradas[ti] > 0 && tt.h > rollWidth) valida = false;
          if (giradas[ti] < Q && tt.w > rollWidth) valida = false;
        }
        if (!valida) continue;
        var extremos = giradas.every(function(g, k) { return g === 0 || g === tipos[k].piezas.length; });
        // Donde van las acostadas dentro de su medida: al principio, al final,
        // repartidas parejo, o repartidas empezando por la otra punta. El orden
        // decide que hueco toma cada una cuando todas miden lo mismo.
        for (var orden = 0; orden < 4; orden++) {
          var lista = [];
          tipos.forEach(function(t, k) {
            var Q = t.piezas.length, g = giradas[k];
            for (var x = 0; x < Q; x++) {
              var acostada;
              if (orden === 0) acostada = x < g;
              else if (orden === 1) acostada = x >= Q - g;
              else if (orden === 2) acostada = Math.floor((x + 1) * g / Q) > Math.floor(x * g / Q);
              else acostada = Math.floor((Q - x) * g / Q) > Math.floor((Q - x - 1) * g / Q);
              lista.push(orientada(t, t.piezas[x], acostada));
            }
          });
          _trabajo += 5 * n;
          probar(lista);
          if (extremos) break;   // todas o ninguna: el orden da igual
        }
      }
    }
    // Pieza por pieza solo donde es barato (hasta 10 piezas: 1024 arreglos), como
    // antes. Ahi el orden exacto de las giradas a veces gana algun centimetro.
    if (n > 12) return best;
    var hasta = Infinity;
    for (var mask = 0; mask < (1 << n); mask++) {
      _trabajo += 5 * n;
      if ((mask & 255) === 0 && _trabajo > hasta) break;
      var oriented = [];
      var ok = true;
      for (var i = 0; i < n; i++) {
        var it = exp[i], rot = (mask >> i) & 1;
        var iw = rot ? it.h : it.w, ih = rot ? it.w : it.h;
        if (iw > rollWidth) { ok = false; break; }
        oriented.push(Object.assign({}, it, { w: iw, h: ih, originalW: it.w, qty: 1 }));
      }
      if (!ok) continue;
      var r = packMaxRects(oriented, rollWidth);
      var rs = mrSueltas(oriented, rollWidth);
      if (rs && (!r || rs.totalLength < r.totalLength)) r = rs;
      if (r && (!best || r.totalLength < best.totalLength)) best = r;
    }
    return best;
  }

// Version del cotizador original: enumera particiones del ancho del rollo y arma
// secciones de columnas. La que habia antes era una simplificacion que en pedidos
// grandes daba hasta 6 veces mas largo de rollo.
function packByColumns(items, rollWidth, cotaInicial) {
  var wSet = {};
  items.forEach(function(it) {
    if (it.w > 0 && it.w <= rollWidth) wSet[it.w] = 1;
    if (it.h > 0 && it.h <= rollWidth) wSet[it.h] = 1;
  });
  var allW = Object.keys(wSet).map(Number).sort(function(a,b){return a-b;});
  // Enumerar las particiones es barato (154 para 8 anchos, ~1ms). Lo caro es la
  // busqueda que las combina hasta 6 niveles: 154^6. Por eso mas abajo recortamos
  // las particiones y arrancamos con una cota que permita podar.
  // Presupuesto: con muchos anchos distintos la enumeracion de particiones crece sin
  // control (8 anchos llegaban a 46 segundos con la pagina congelada). Cortamos por
  // trabajo (TOPE_PARTICIONES, TOPE_BUSQUEDA) y por cantidad, y devolvemos lo
  // mejor hallado hasta ese punto.
  var _MAXPARTS = 4000, _nPart = 0, _nBusq = 0;
  var wParts = [], _cortado = false;
  (function fp(rem, cur, mi) {
    if (wParts.length >= _MAXPARTS || ++_nPart > TOPE_PARTICIONES) { _cortado = true; return; }
    if (rem === 0) { wParts.push(cur.slice()); return; }
    if (cur.length > 8) return;
    for (var i = mi; i < allW.length; i++) {
      if (allW[i] <= rem) { cur.push(allW[i]); fp(rem-allW[i], cur, i); cur.pop(); }
    }
  })(rollWidth, [], 0);
  // Nos quedamos con las mas prometedoras: pocas columnas (secciones mas simples)
  // y anchos de los que hay muchas piezas disponibles para llenarlas.
  var _MAXPARTS_USO = 150;
  if (wParts.length > _MAXPARTS_USO) {
    var _cant = {};
    items.forEach(function(it) {
      _cant[it.w] = (_cant[it.w] || 0) + it.qty;
      _cant[it.h] = (_cant[it.h] || 0) + it.qty;
    });
    wParts = wParts.map(function(p) {
      var cob = 0;
      for (var k = 0; k < p.length; k++) cob += (_cant[p[k]] || 0);
      return { p: p, cols: p.length, cob: cob };
    }).sort(function(a, b) {
      return a.cols - b.cols || b.cob - a.cob;
    }).slice(0, _MAXPARTS_USO).map(function(o) { return o.p; });
  }

  // Arrancar con una cota conocida (la de maxrects) es lo que hace viable la busqueda:
  // sin ella, la poda "no explores ramas peores que la mejor" no puede actuar hasta
  // encontrar la primera solucion completa, y mientras tanto explora a ciegas.
  var best = (cotaInicial && isFinite(cotaInicial)) ? { totalLength: cotaInicial, acc: null } : null;
  function trySection(remQty, wPart) {
    var cByW = {};
    wPart.forEach(function(w) { cByW[w] = (cByW[w]||0)+1; });
    var sLen = Infinity, wData = {};
    // First pass: build opts and compute sLen per column type
    for (var cw in cByW) {
      cw = +cw;
      var nc = cByW[cw], opts = [], tah = 0;
      items.forEach(function(it,idx) {
        var av = remQty[idx]; if (av<=0) return;
        if (it.w===cw) { opts.push({idx:idx,fitH:it.h,avail:av,rotated:false}); tah+=av*it.h; }
        else if (it.h===cw&&it.w!==it.h) { opts.push({idx:idx,fitH:it.w,avail:av,rotated:true}); tah+=av*it.w; }
      });
      if (!opts.length||!tah) return null;
      // Use ceil(qty/nc)*fitH for uniform items to avoid fractional sections
      var allSame = opts.every(function(o){ return o.fitH===opts[0].fitH; });
      var slCw;
      if (allSame) {
        var totalQty = opts.reduce(function(s,o){ return s+remQty[o.idx]; }, 0);
        slCw = Math.ceil(totalQty/nc) * opts[0].fitH;
      } else {
        slCw = tah/nc;
      }
      sLen = Math.min(sLen, slCw);
      wData[cw] = {nc:nc,opts:opts};
    }
    if (!isFinite(sLen)||sLen<=0) return null;
    // Second pass: filter items that don't fit in sLen, recompute sLen
    for (var cw in cByW) {
      cw = +cw;
      var data = wData[cw];
      var validOpts = data.opts.filter(function(o){ return o.fitH<=sLen; });
      if (!validOpts.length) return null;
      var tah2 = 0;
      validOpts.forEach(function(o){ tah2+=remQty[o.idx]*o.fitH; });
      if (!tah2) return null;
      var allSame = validOpts.every(function(o){ return o.fitH===validOpts[0].fitH; });
      var slCw;
      if (allSame) {
        var totalQty = validOpts.reduce(function(s,o){ return s+remQty[o.idx]; }, 0);
        slCw = Math.ceil(totalQty/data.nc) * validOpts[0].fitH;
      } else {
        slCw = tah2/data.nc;
      }
      sLen = Math.min(sLen, slCw);
      data.opts = validOpts;
    }
    if (!isFinite(sLen)||sLen<=0) return null;
    var used = remQty.map(function(){return 0;}), actualUsed = remQty.map(function(){return 0;}), secCols = [], colX = 0;
    for (var cw in cByW) {
      cw = +cw;
      var data = wData[cw], nc = data.nc, pool = [], ta = sLen*nc;
      for (var oi=0; oi<data.opts.length&&ta>0.5; oi++) {
        var o=data.opts[oi], av=o.avail-(used[o.idx]||0); if (av<=0) continue;
        var tk=Math.min(av,Math.floor(ta/o.fitH)); if(tk<=0) continue;
        pool.push({fitH:o.fitH,qty:tk,idx:o.idx,rotated:o.rotated});
        used[o.idx]=(used[o.idx]||0)+tk; ta-=tk*o.fitH;
      }
      if (!pool.length) return null;
      for (var ci=0; ci<nc; ci++) {
        var pls=[],yp=0,rem2=sLen;
        for (var ii=0; ii<pool.length&&rem2>=pool[ii].fitH-0.5; ii++) {
          if(pool[ii].qty<=0) continue;
          var tk2=Math.min(pool[ii].qty,Math.floor(rem2/pool[ii].fitH));
          if(tk2<=0) continue;
          var it2=items[pool[ii].idx];
          for(var k=0;k<tk2;k++){
            pls.push({x:colX,y:yp,w:cw,h:pool[ii].fitH,label:it2.label,color:it2.color,rotated:pool[ii].rotated});
            yp+=pool[ii].fitH;
          }
          actualUsed[pool[ii].idx]=(actualUsed[pool[ii].idx]||0)+tk2;
          pool[ii].qty-=tk2; rem2-=tk2*pool[ii].fitH;
        }
        secCols.push({colX:colX,colW:cw,placements:pls}); colX+=cw;
      }
    }
    return {sLen:sLen,used:actualUsed,secCols:secCols};
  }
  function search(remQty, totalLen, acc, depth) {
    if (!remQty.some(function(q){return q>0;})) {
      var len=Math.max(totalLen,TABLE_MIN);
      if (!best||len<best.totalLength) best={totalLength:len,acc:acc};
      return;
    }
    if (depth>6||(best&&totalLen>=best.totalLength)) return;
    for (var pi=0; pi<wParts.length; pi++) {
      // Cada intento cuesta segun cuantas medidas y columnas mira
      _nBusq += items.length * wParts[pi].length;
      if (_nBusq > TOPE_BUSQUEDA) { _cortado = true; break; }
      var r=trySection(remQty,wParts[pi]);
      if (!r||r.sLen<=0) continue;
      if (best&&totalLen+r.sLen>=best.totalLength) continue;
      var nr=remQty.map(function(q,i){return q-(r.used[i]||0);});
      if (nr.some(function(q){return q<0;})) continue;
      search(nr,totalLen+r.sLen,acc.concat([{sl:r.sLen,cols:r.secCols}]),depth+1);
    }
  }
  search(items.map(function(it){return it.qty;}),0,[],0);

  // Segunda vuelta: particiones que dejan un sobrante donde ya no cabe ninguna
  // columna. 50+50 en el rollo de 110 deja 10 cm libres y es la mejor forma de
  // poner 50x40: con solo las exactas (70+40), 16 de 50x40 con 2 de 50x70 daban
  // 390 cm en vez de 380. Va DESPUES y solo si la primera vuelta termino sin
  // cortarse por tiempo: mezcladas desde el principio, en pedidos con muchas
  // medidas se comian el presupuesto y el de 330 piezas subia $25.000. Asi el
  // resultado nunca es peor que el de antes; a lo mas, mejor.
  if (!_cortado) {
    var wSobra = [];
    _nPart = 0;
    (function fs(rem, cur, mi) {
      if (wSobra.length >= _MAXPARTS || ++_nPart > TOPE_PARTICIONES) return;
      if (rem === 0) return;   // las exactas ya se probaron
      if (cur.length && rem < allW[0]) { wSobra.push(cur.slice()); return; }
      if (cur.length > 8) return;
      for (var i = mi; i < allW.length; i++) {
        if (allW[i] <= rem) { cur.push(allW[i]); fs(rem-allW[i], cur, i); cur.pop(); }
      }
    })(rollWidth, [], 0);
    if (wSobra.length) {
      wParts = wParts.concat(wSobra);
      if (wParts.length > _MAXPARTS_USO) {
        var _cant2 = {};
        items.forEach(function(it) {
          _cant2[it.w] = (_cant2[it.w] || 0) + it.qty;
          _cant2[it.h] = (_cant2[it.h] || 0) + it.qty;
        });
        wParts = wParts.map(function(p) {
          var cob = 0;
          for (var k = 0; k < p.length; k++) cob += (_cant2[p[k]] || 0);
          return { p: p, cols: p.length, cob: cob };
        }).sort(function(a, b) {
          return a.cols - b.cols || b.cob - a.cob;
        }).slice(0, _MAXPARTS_USO).map(function(o) { return o.p; });
      }
      _nBusq = 0;   // presupuesto propio para esta vuelta
      search(items.map(function(it){return it.qty;}),0,[],0);
    }
  }
  // best.acc queda en null si solo tenemos la cota de entrada: no mejoramos nada
  if (!best || !best.acc) return null;
  var shelves=[],sy=0;
  best.acc.forEach(function(sec) {
    sec.cols.forEach(function(col) {
      col.placements.forEach(function(p) {
        shelves.push({y:sy+p.y,height:p.h,usedWidth:rollWidth,placements:[{x:p.x,y:sy+p.y,w:p.w,h:p.h,label:p.label,color:p.color,rotated:p.rotated}]});
      });
    });
    sy+=sec.sl;
  });
  return {totalLength:best.totalLength,shelves:shelves};
  }

// Columnas parejas: el ancho del rollo se parte en columnas (con los anchos de
// las piezas) y cada pieza va a la columna donde el rollo termine mas corto.
// packByColumns no hace eso: llena una columna con todo lo que cabe y la otra
// recibe lo que sobra. 9 de 70x50 + 9 de 70x40 en el rollo de 110 (columnas de
// 70 y 40): llenando primero la de 70 daba 570 cm; repartiendo parejo, 530.
//
// Sin presupuesto de tiempo, a proposito: con un tope de trabajo fijo da el mismo
// resultado en un celular lento, en el computador y en el Apps Script que cobra.
function packColumnasParejas(items, rollWidth) {
  var tipos = items.filter(function(it) { return it.qty > 0 && it.w > 0 && it.h > 0; });
  if (!tipos.length) return null;
  var totalPiezas = 0;
  tipos.forEach(function(it) { totalPiezas += it.qty; });
  // Sobre 300 piezas el reparto pieza a pieza deja de ser barato, y en esos
  // pedidos packByColumns y las filas ya acomodan bien.
  if (totalPiezas > 300) return null;
  var anchos = {};
  tipos.forEach(function(it) {
    if (it.w <= rollWidth) anchos[it.w] = 1;
    if (it.h <= rollWidth) anchos[it.h] = 1;
  });
  var S = Object.keys(anchos).map(Number).sort(function(a, b) { return b - a; });
  if (!S.length) return null;
  var minS = S[S.length - 1], nT = tipos.length;
  var MAX_PARTICIONES = 300, MAX_TRABAJO = 3000000;
  var vistas = 0, trabajo = 0, best = null;

  // Lo que suma al largo una pieza en una columna de ancho cw (null: no cabe).
  // De las orientaciones que caben, la mas corta: el ancho que sobra se pierde igual.
  function aporte(it, cw) {
    var m = null;
    if (it.w <= cw) m = { largo: it.h, ancho: it.w, rot: false };
    if (it.h <= cw && (!m || it.w < m.largo)) m = { largo: it.w, ancho: it.h, rot: true };
    return m;
  }

  function evaluar(cols) {
    var nC = cols.length, a = [], t, c, s;
    for (t = 0; t < nT; t++) {
      var fila = [], alguna = false;
      for (c = 0; c < nC; c++) { var ap = aporte(tipos[t], cols[c]); fila.push(ap); if (ap) alguna = true; }
      if (!alguna) return;   // una medida que no cabe en ninguna columna
      a.push(fila);
    }
    var len = cols.map(function() { return 0; });
    var cnt = cols.map(function() { return tipos.map(function() { return 0; }); });
    // Primero las medidas con menos columnas posibles; entre ellas, las mas largas
    function posibles(t) { return a[t].filter(Boolean); }
    var orden = tipos.map(function(x, i) { return i; }).sort(function(i, j) {
      var pi = posibles(i), pj = posibles(j);
      if (pi.length !== pj.length) return pi.length - pj.length;
      var mi = Math.max.apply(null, pi.map(function(z) { return z.largo; }));
      var mj = Math.max.apply(null, pj.map(function(z) { return z.largo; }));
      return mj - mi || i - j;
    });
    orden.forEach(function(t) {
      for (var q = 0; q < tipos[t].qty; q++) {
        var bc = -1;
        for (var c2 = 0; c2 < nC; c2++) {
          trabajo++;
          if (!a[t][c2]) continue;
          if (bc < 0 || len[c2] + a[t][c2].largo < len[bc] + a[t][bc].largo - 1e-9) bc = c2;
        }
        len[bc] += a[t][bc].largo; cnt[bc][t]++;
      }
    });
    // Repaso: sacar algo de la columna mas larga, moviendolo o cambiandolo por
    // una pieza de otra columna, mientras el largo baje.
    for (var paso = 0; paso < 300 && trabajo < MAX_TRABAJO; paso++) {
      var i = 0, hecho = false;
      for (c = 1; c < nC; c++) if (len[c] > len[i] + 1e-9) i = c;
      for (t = 0; t < nT && !hecho; t++) {
        if (!cnt[i][t]) continue;
        for (c = 0; c < nC && !hecho; c++) {
          trabajo++;
          if (c === i || !a[t][c]) continue;
          var ni = len[i] - a[t][i].largo, nc = len[c] + a[t][c].largo;
          if (Math.max(ni, nc) < len[i] - 1e-9) {
            len[i] = ni; len[c] = nc; cnt[i][t]--; cnt[c][t]++; hecho = true;
          }
        }
      }
      for (t = 0; t < nT && !hecho; t++) {
        if (!cnt[i][t]) continue;
        for (c = 0; c < nC && !hecho; c++) {
          if (c === i || !a[t][c]) continue;
          for (s = 0; s < nT && !hecho; s++) {
            trabajo++;
            if (s === t || !cnt[c][s] || !a[s][i]) continue;
            var ni2 = len[i] - a[t][i].largo + a[s][i].largo;
            var nc2 = len[c] - a[s][c].largo + a[t][c].largo;
            if (Math.max(ni2, nc2) < len[i] - 1e-9) {
              len[i] = ni2; len[c] = nc2;
              cnt[i][t]--; cnt[c][t]++; cnt[c][s]--; cnt[i][s]++; hecho = true;
            }
          }
        }
      }
      if (!hecho) break;
    }
    var L = Math.max.apply(null, len);
    if (!best || L < best.L - 1e-9) {
      best = { L: L, cols: cols.slice(), a: a, cnt: cnt.map(function(r) { return r.slice(); }) };
    }
  }

  // Particiones del ancho con los anchos de las piezas, de mayor a menor, hasta
  // que en lo que sobra ya no quepa ninguna columna. Una columna de mas nunca
  // alarga el rollo (puede quedar vacia), asi que basta con las completas.
  (function fp(rem, cur, mi) {
    if (vistas >= MAX_PARTICIONES || trabajo >= MAX_TRABAJO) return;
    if (cur.length && (rem < minS || cur.length >= 12)) { vistas++; evaluar(cur); return; }
    for (var k = mi; k < S.length; k++) {
      if (S[k] <= rem) { cur.push(S[k]); fp(rem - S[k], cur, k); cur.pop(); }
    }
  })(rollWidth, [], 0);
  if (!best) return null;

  // El acomodo dibujado, en el mismo formato que packByColumns
  var shelves = [], x = 0;
  best.cols.forEach(function(cw, c) {
    var y = 0;
    for (var t = 0; t < nT; t++) {
      var ap = best.a[t][c], it = tipos[t];
      for (var q = 0; q < best.cnt[c][t]; q++) {
        shelves.push({ y: y, height: ap.largo, usedWidth: rollWidth,
          placements: [{ x: x, y: y, w: ap.ancho, h: ap.largo, label: it.label, color: it.color, rotated: ap.rot }] });
        y += ap.largo;
      }
    }
    x += cw;
  });
  return { totalLength: best.L, shelves: shelves };
}

// budgetMs ya no se usa: las vueltas salen de TRABAJO_REPASO y el orden «al azar»
// sale de una secuencia fija, para que el mismo pedido de siempre lo mismo.
function packLocalSearch(items, rollWidth, currentBest, budgetMs) {
  var best = currentBest;
  var oriented = preOptimizeRotations(items, rollWidth).filter(function(x) { return x.fits; });
  if (!oriented.length) return best;
  var piezas = 0;
  oriented.forEach(function(x) { piezas += x.qty; });
  var vueltas = Math.max(5, Math.min(200, Math.floor(TRABAJO_REPASO / Math.max(1, piezas))));
  var semilla = 20261025;
  function azar() { semilla = (Math.imul(semilla, 1103515245) + 12345) >>> 0; return semilla / 4294967296; }

  function tryPerm(arr) {
    var r = packShelfFixed(arr, rollWidth);
    if (!best || r.totalLength < best.totalLength) best = r;
  }

  // Ordenes mezclados, siempre los mismos para el mismo pedido
  for (var iter = 0; iter < vueltas; iter++) {
    var shuffled = oriented.slice();
    for (var i = shuffled.length - 1; i > 0; i--) {
      var j = Math.floor(azar() * (i + 1));
      var tmp = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = tmp;
    }
    tryPerm(shuffled);
  }
  return best;
}

function packPerfectRows(items, rollWidth) {
  // group same-size items into rows that perfectly fill rollWidth
  var units = [];
  items.forEach(function(it) {
    for (var q = 0; q < it.qty; q++) {
      var w = it.w, h = it.h;
      if (w > rollWidth && h <= rollWidth) { var tmp = w; w = h; h = tmp; }
      units.push({ w: w, h: h, label: it.label, color: it.color });
    }
  });
  units.sort(function(a, b) { return b.h - a.h || b.w - a.w; });
  var rows = [], curRow = null;
  units.forEach(function(u) {
    var placed = false;
    if (curRow && (curRow.x + u.w) <= rollWidth + 0.01) {
      curRow.items.push({ x: curRow.x, y: curRow.y, w: u.w, h: u.h, label: u.label, color: u.color });
      curRow.x += u.w;
      curRow.h = Math.max(curRow.h, u.h);
      placed = true;
    }
    if (!placed) {
      var y = curRow ? curRow.y + curRow.h : 0;
      curRow = { x: u.w, y: y, h: u.h, items: [{ x: 0, y: y, w: u.w, h: u.h, label: u.label, color: u.color }] };
      rows.push(curRow);
    }
  });
  var allPlaced = [];
  rows.forEach(function(r) { r.items.forEach(function(p) { allPlaced.push(p); }); });
  var totalLength = allPlaced.reduce(function(mx, p) { return Math.max(mx, p.y + p.h); }, 0);
  return { shelves: allPlaced, totalLength: totalLength, isMaxRects: true };
}

// Piezas todas iguales: el ancho del rollo se parte en dos franjas de columnas,
// unas sin girar y otras giradas, y las piezas se reparten entre ellas.
//
// 60x40 en rollo de 110: una columna de 60 (cada pieza aporta 40 de largo) y
// otra de 40 (cada pieza aporta 60). Con 100 piezas, 60 en la primera y 40 en
// la segunda dan 24 m; apilando filas de una sola pieza serian 30 m.
function packFranjas(items, rollWidth) {
  var w = null, h = null, qty = 0, modelo = null;
  for (var i = 0; i < items.length; i++) {
    var it = items[i];
    if (!(it.qty >= 1) || !(it.w > 0) || !(it.h > 0)) return null;
    if (w === null) { w = it.w; h = it.h; modelo = it; }
    // Una pieza girada sigue siendo la misma pieza
    else if (!((it.w === w && it.h === h) || (it.w === h && it.h === w))) return null;
    qty += it.qty;
  }
  if (w === null || qty < 1) return null;

  var maxNat = w <= rollWidth ? Math.floor(rollWidth / w) : 0;
  var maxRot = h <= rollWidth ? Math.floor(rollWidth / h) : 0;
  if (!maxNat && !maxRot) return null;

  var mejor = null;
  for (var a = 0; a <= maxNat; a++) {
    for (var b = 0; b <= maxRot; b++) {
      if (a === 0 && b === 0) continue;
      if (a * w + b * h > rollWidth + 1e-9) continue;
      for (var nNat = 0; nNat <= qty; nNat++) {
        var nRot = qty - nNat;
        if (nNat > 0 && a === 0) continue;
        if (nRot > 0 && b === 0) continue;
        var L = Math.max(a ? Math.ceil(nNat / a) * h : 0,
                         b ? Math.ceil(nRot / b) * w : 0);
        if (mejor === null || L < mejor.L) mejor = { L: L, a: a, b: b, nNat: nNat };
      }
    }
  }
  if (!mejor) return null;

  // El acomodo dibujado, para el diagrama del rollo
  var lugares = [], k;
  var etq = modelo.label, col = modelo.color;
  for (k = 0; k < mejor.nNat; k++) {
    lugares.push({ x: (k % mejor.a) * w, y: Math.floor(k / mejor.a) * h,
                   w: w, h: h, rotated: false, label: etq, color: col, originalW: w });
  }
  var x0 = mejor.a * w;
  for (k = 0; k < qty - mejor.nNat; k++) {
    lugares.push({ x: x0 + (k % mejor.b) * h, y: Math.floor(k / mejor.b) * w,
                   w: h, h: w, rotated: true, label: etq, color: col, originalW: w });
  }
  var largo = lugares.reduce(function(m, p) { return Math.max(m, p.y + p.h); }, 0);
  return { shelves: lugares, totalLength: largo, isMaxRects: true };
}

function packShelf(items, rollWidth) {
  var conCantidad = items.filter(function(it) { return it.qty > 0; });
  if (!conCantidad.length) return null;

  // Si UNA sola pieza no cabe en este ancho, el rollo no sirve para el pedido completo.
  // Antes se filtraba la pieza y se acomodaba el resto: el precio salia mas barato
  // pero dejaba piezas fuera del pedido, que habria que imprimir sin cobrar.
  var validItems = conCantidad.filter(function(it) { return Math.min(it.w, it.h) <= rollWidth; });
  if (validItems.length !== conCantidad.length) return null;

  // Ojo: preOptimizeRotations puede partir un item en dos (parte rotada + parte
  // natural), asi que no sirve comparar largos: revisamos que ninguno quede sin caber.
  var pre = preOptimizeRotations(validItems, rollWidth);
  if (pre.some(function(x) { return !x.fits; })) return null;
  var oriented = pre.filter(function(x) { return x.qty > 0; });
  if (!oriented.length) return null;

  var candidates = [];

  // Franjas de columnas: solo sirve con piezas iguales, y sale de las medidas
  // originales, no de las ya rotadas por preOptimizeRotations.
  var sf = packFranjas(conCantidad, rollWidth);
  if (sf) candidates.push(sf);

  // Strategy 1: shelf variants
  var s1 = packShelfFixed(oriented, rollWidth);
  if (s1) candidates.push(s1);

  // Strategy 2: MaxRects. Compara cada pieza contra todas las demas, asi que el
  // trabajo crece al cuadrado: 6000 piezas le toman 3,2 s y a packShelfFixed 1 ms
  // para el MISMO largo. Sobre 2000 piezas no aporta y congela la pagina.
  var totalPiezas = 0;
  for (var tp = 0; tp < conCantidad.length; tp++) totalPiezas += conCantidad[tp].qty;
  if (totalPiezas <= 2000) {
    var s2 = packMaxRects(oriented, rollWidth);
    if (s2) candidates.push(s2);
  }

  // Strategy 3: Brute (small sets)
  var s3 = packBruteOrientations(validItems, rollWidth);
  var s3b = packBrutaPorPieza(validItems, rollWidth);
  if (s3b && (!s3 || s3b.totalLength < s3.totalLength)) s3 = s3b;
  if (s3) candidates.push(s3);

  // Strategy 4: Columns
  // Le damos como cota lo mejor que llevamos: con eso poda desde el primer paso.
  var _cota = null;
  for (var _ci = 0; _ci < candidates.length; _ci++) {
    if (_cota === null || candidates[_ci].totalLength < _cota) _cota = candidates[_ci].totalLength;
  }
  var s4 = packByColumns(validItems, rollWidth, _cota);
  if (s4) candidates.push(s4);

  // Strategy 5: Perfect rows
  var s5 = packPerfectRows(oriented, rollWidth);
  if (s5) candidates.push(s5);

  // Strategy 6: columnas parejas (se suma, no reemplaza nada)
  var s6 = packColumnasParejas(validItems, rollWidth);
  if (s6) candidates.push(s6);

  if (!candidates.length) return null;
  var best = candidates.reduce(function(a, b) { return b.totalLength < a.totalLength ? b : a; });

  // Local search polish (vueltas fijas, ver packLocalSearch)
  best = packLocalSearch(validItems, rollWidth, best, 50);

  return best;
}

function packCacheado(items, rollW) {
  var clave = rollW + "|";
  for (var i = 0; i < items.length; i++) {
    clave += items[i].qty + "x" + items[i].w + "x" + items[i].h + ",";
  }
  if (Object.prototype.hasOwnProperty.call(_packCache, clave)) return _packCache[clave];
  var r = packShelf(items, rollW);
  _packCache[clave] = r;
  _packOrden.push(clave);
  if (_packOrden.length > 30) { delete _packCache[_packOrden.shift()]; }
  return r;
}

// Las piezas de un acomodo, vengan en la forma que vengan.
function piezasDelPack(pack) {
  var out = [];
  ((pack && pack.shelves) || []).forEach(function(sh) {
    if (!sh) return;
    if (sh.w !== undefined && sh.x !== undefined) { out.push(sh); return; }
    var lista = sh.placements || sh.items;
    if (lista && lista.forEach) lista.forEach(function(p) { out.push(p); });
  });
  return out;
}

// Los rectangulos libres mas grandes dentro del area ya usada. Traido del
// cotizador anterior: se parte el rollo entero y se le va restando cada pieza,
// quedandose solo con los pedazos que no estan contenidos en otro.
function huecosLibres(piezas, rollWidth, totalLength) {
  var free = [{ x: 0, y: 0, w: rollWidth, h: totalLength }];
  for (var i = 0; i < piezas.length; i++) {
    var p = piezas[i], nf = [];
    for (var j = 0; j < free.length; j++) {
      var f = free[j];
      if (p.x >= f.x + f.w || p.x + p.w <= f.x || p.y >= f.y + f.h || p.y + p.h <= f.y) { nf.push(f); continue; }
      if (p.x > f.x)               nf.push({ x: f.x,       y: f.y,       w: p.x - f.x,               h: f.h });
      if (p.x + p.w < f.x + f.w)   nf.push({ x: p.x + p.w, y: f.y,       w: f.x + f.w - p.x - p.w,   h: f.h });
      if (p.y > f.y)               nf.push({ x: f.x,       y: f.y,       w: f.w,                     h: p.y - f.y });
      if (p.y + p.h < f.y + f.h)   nf.push({ x: f.x,       y: p.y + p.h, w: f.w,                     h: f.y + f.h - p.y - p.h });
    }
    free = nf.filter(function(a, ai) {
      return !nf.some(function(b, bi) {
        return ai !== bi && b.x <= a.x && b.y <= a.y &&
               b.x + b.w >= a.x + a.w && b.y + b.h >= a.y + a.h;
      });
    });
  }
  return free;
}

// Los huecos que sirven para imprimir algo. Minimo 10 cm porque es el minimo
// de pieza del cotizador, y maximo 200 porque un hueco de un rollo largo puede
// dar 744 cm y nadie encarga una impresion de siete metros y medio.
function sugerenciasSobrante(pack, rollWidth, totalLength) {
  if (!pack || !(totalLength > 0)) return [];
  var libres = huecosLibres(piezasDelPack(pack), rollWidth, totalLength);
  var out = [];
  libres.forEach(function(f) {
    var w = Math.min(Math.floor(f.w), 200), h = Math.min(Math.floor(f.h), 200);
    if (w >= 10 && h >= 10) out.push({ x: f.x, y: f.y, w: w, h: h, area: w * h });
  });
  out.sort(function(a, b) { return b.area - a.area; });
  var vistas = {}, unicas = [];
  out.forEach(function(f) {
    var k = f.w + 'x' + f.h;
    if (vistas[k]) return;
    vistas[k] = 1; unicas.push(f);
  });
  return unicas.slice(0, 8);
}

// Ofrecer un hueco solo si de verdad no cuesta nada. Agregar una pieza cambia
// el acomodo, y a veces el motor termina usando mas rollo: medido, pasaba en 34
// de 454 sugerencias, una de ellas +$8.500. Aca se cotiza el pedido CON la
// pieza y solo sobreviven las que dejan el precio intacto.
function sobrantesQueNoCuestan(items, paperId, ganador) {
  if (!ganador) return [];
  var base = Math.round(ganador.price);
  var cand = sugerenciasSobrante(ganador.pack, ganador.rollW, ganador.realLength);
  var buenas = [];
  for (var i = 0; i < cand.length && buenas.length < 4; i++) {
    var f = cand[i];
    var conPieza = items.concat([{ qty: 1, w: f.w, h: f.h }]);
    var o = calculateOrder(conPieza, paperId);
    if (o && o.winner && Math.round(o.winner.price) === base) buenas.push(f);
  }
  return buenas;
}

function calculateOrder(items, paperId) {
  // Las filas a medio llenar no entran al cálculo (igual que el original)
  items = (items || []).filter(function(it) { return it.w > 0 && it.h > 0 && it.qty >= 1; });
  if (!items.length) return null;

  // Bajo 10 cm de lado no se cotiza. El precio sale del papel usado, y a ese
  // tamano el papel no es lo que cuesta: preparar, cortar y despachar si.
  if (items.some(function(it) { return Math.min(it.w, it.h) < ladoMin(); })) return null;
  var paper = getPaper(paperId);
  if (!paper) return null;

  var totalPrintArea = items.reduce(function(s, it) { return s + it.w * it.h * it.qty; }, 0);

  var rollWidths = _forcedRoll ? [_forcedRoll] : [60, 110];
  var results = rollWidths.map(function(rollW) {
    var paperIdx = rollW === 60 ? paper.r60 : paper.r110;
    if (paperIdx === null || paperIdx === undefined) return { rollW: rollW, available: false };
    var pack = packCacheado(items, rollW);
    if (!pack) return { rollW: rollW, available: false };
    // El minimo del rollo de 60 se puede rebajar con control+clic en el precio.
    // El de 110 no cambia nunca.
    var minRollLen = rollW === 60 ? _min60 : TABLE_MIN;
    var realLength = pack.totalLength;
    var totalLength = Math.max(realLength, minRollLen);
    var belowMin = !_god && realLength < minRollLen;
    var rollArea = rollW * realLength;
    var wastePct = totalPrintArea > 0 ? Math.max(0, Math.round((1 - totalPrintArea / rollArea) * 100)) : 0;
    var priceTable = rollW === 60 ? PRICES_60 : PRICES_110;
    var pricingLength = Math.max(realLength, TABLE_MIN);
    var pr = interpolatePrice(priceTable, paperIdx, pricingLength);
    return { rollW: rollW, available: true, pack: pack, realLength: realLength, totalLength: totalLength, belowMin: belowMin, minRollLen: minRollLen, rollArea: rollArea, wastePct: wastePct, price: pr.price, extrapolated: pr.extrapolated };
  });

  var available = results.filter(function(r) { return r.available; });
  if (!available.length) return null;
  available.sort(function(a, b) { return a.price - b.price || a.wastePct - b.wastePct; });
  var winner = available[0];
  return { winner: winner, paper: paper, items: items, totalPieces: items.reduce(function(s, it) { return s + it.qty; }, 0) };
}

function getPaper(id) {
  for (var i = 0; i < PAPERS.length; i++) if (PAPERS[i].id === id) return PAPERS[i];
  return null;
}

function getSize(id) {
  for (var i = 0; i < SIZES.length; i++) if (SIZES[i].id === id) return SIZES[i];
  return null;
}

function fmtCLP(n) {
  return '$' + Math.round(n).toLocaleString('es-CL');
}

function sa(s) { return stripAccents(String(s).toLowerCase()); }

function stripAccents(s) { return s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }

function detectPaper(text) {
  return papelDelTexto(text) || 'fs-smooth';
}

// Lo mismo, pero devuelve null cuando el texto NO nombra ningun papel. La
// diferencia importa: en la pagina de un papel, "2 30x40" no nombra ninguno, y
// tratarlo como Smooth hacia saltar un aviso sobre un papel que nadie escribio.
function papelDelTexto(text) {
  // Palabra completa, no subcadena: "cartelas" y "estela" contienen "tela"
  // pero no son canvas.
  var t = stripAccents(String(text || '').toLowerCase());
  for (var i = 0; i < PAPEL_CLAVES.length; i++) {
    if (PAPEL_CLAVES[i].re.test(t)) return PAPEL_CLAVES[i].id;
  }
  return null;
}

// Devuelve null cuando NO hay cantidad explícita. Es la diferencia clave con la
// versión anterior, que tomaba el primer número del texto (el ancho de "60x40")
// y lo usaba como cantidad.
function extractQty(str) {
  var low = sa(str);
  var keys = Object.keys(WORD_NUMS).sort(function(a, b) { return b.length - a.length; });
  for (var i = 0; i < keys.length; i++) {
    if (new RegExp('\\b' + keys[i] + '\\b').test(low)) return WORD_NUMS[keys[i]];
  }
  var nums = String(str).match(/(\d+)/g);
  if (nums) return parseInt(nums[nums.length - 1], 10);
  return null;
}

// Devuelve la medida TAL CUAL se interpretó — mismo criterio que el cotizador
// en producción: no se ajusta al catálogo ni se fuerzan mínimos en este punto.
// (El ajuste anterior hacía que 20x30 se convirtiera en A4 por estar a <1,5cm.)
function rawSize(w, h, qty) {
  return { found: true, w: w, h: h, qty: qty, sizeId: null };
}

// Todos los numeros del texto, con lo que tienen alrededor.
function nlpNumeros(txt) {
  var out = [], re = /(\d+(?:[.,]\d+)?)/g, m;
  while ((m = re.exec(txt))) {
    var i = m.index, fin = i + m[0].length;
    out.push({
      valor: parseFloat(m[0].replace(',', '.')),
      i: i, fin: fin,
      antes: txt.slice(Math.max(0, i - 20), i),
      despues: txt.slice(fin, fin + 20),
      entero: !/[.,]/.test(m[0]),
      usado: false
    });
  }
  return out;
}

// Un par de numeros unidos por x, *, "por" o "by" es una medida candidata.
// Se prefiere el par que cabe en lo que la imprenta puede hacer.
function nlpPares(txt, nums, aCm) {
  var out = [];
  for (var a = 0; a < nums.length - 1; a++) {
    var b = a + 1;
    var medio = txt.slice(nums[a].fin, nums[b].i);
    // La unidad puede venir pegada a los dos numeros: "30cm x 40cm".
    if (!/^\s*(?:mm|cms?|m)?\s*(?:[xX\u00d7*]|por|by)\s*$/.test(medio)) continue;
    // La unidad suele escribirse una sola vez, al final: "300x400 mm".
    // Si el primer numero no la trae, hereda la del segundo.
    var uniA = /^\s*(m|mm|cms?)\b/.test(nums[a].despues) ? nums[a].despues : nums[b].despues;
    var w = aCm(nums[a].valor, uniA);
    var h = aCm(nums[b].valor, nums[b].despues);
    var corto = Math.min(w, h), largo = Math.max(w, h);
    out.push({
      a: nums[a], b: nums[b], w: w, h: h,
      cabe: corto >= ladoMin() && corto > 0 && corto <= 110 && largo <= 200
    });
  }
  return out;
}

// ¿Que tan probable es que este numero sea la cantidad?
function nlpPuntaje(n, medida) {
  if (!n.entero || n.valor < 1) return -100;   // 2,5 laminas no existe
  var antes = sa(n.antes), despues = sa(n.despues);
  var p = 0;

  // Una palabra de cantidad al lado es la senal mas fuerte
  if (NLP_CANT.test(despues.slice(0, 14))) p += 40;
  if (NLP_CANT.test(antes.slice(-14)))     p += 30;

  // Entre parentesis casi siempre es la cantidad: "(40)", "(40 prints)"
  if (/\(\s*$/.test(n.antes) && /^[^()]{0,16}\)/.test(n.despues)) p += 35;

  // Un papel pegado al numero dice lo mismo que "copias": "2 canvas de 50x70"
  if (NLP_PAPEL.test(despues)) p += 35;

  // "version 2", "opcion 3": el numero nombra el archivo, no cuantos son
  if (NLP_CONTEXTO.test(antes))             p -= 60;

  // Pegado a un folio, una fecha o un dato tecnico: no es cantidad
  if (NLP_RUIDO.test(antes.slice(-16)))     p -= 80;
  if (NLP_MES.test(despues.slice(0, 16)))   p -= 80;
  if (NLP_TECNICO.test(despues))            p -= 60;
  if (NLP_UNIDAD.test(despues))             p -= 30;

  // A igualdad de todo, gana el mas cercano a la medida. El tope llega a 25
  // porque "4 de 30x40" no trae ninguna palabra que respalde el 4: si la
  // cercania no alcanza sola para el umbral de 20, la forma mas comun de
  // escribir un pedido queda marcada como dudosa para siempre.
  if (medida) {
    var d = Math.min(Math.abs(n.i - medida.a.i), Math.abs(n.i - medida.b.fin));
    p += Math.max(0, 25 - d / 2);
  }
  // Un numero mayor que el tope de piezas no puede ser una cantidad. Antes el
  // corte estaba en 500 y se comia pedidos reales: "5000 de 10x15" devolvia
  // una sola lamina. Los folios siguen cubiertos por NLP_RUIDO, que mira la
  // palabra de al lado ("orden", "boleta", "#").
  if (n.valor > MAX_QTY && !NLP_CANT.test(antes + ' ' + despues)) p -= 40;
  return p;
}

// La cantidad escrita con palabras: "cuarenta de 24x32"
function nlpCantidadEnPalabras(txt) {
  var bajo = sa(txt);
  var claves = Object.keys(WORD_NUMS).sort(function(a, b) { return b.length - a.length; });
  for (var i = 0; i < claves.length; i++) {
    if (new RegExp('\\b' + claves[i] + '\\b').test(bajo)) return WORD_NUMS[claves[i]];
  }
  return null;
}

function parseSegment(seg) {
  seg = String(seg).trim();
  if (!seg) return { found: false };
  var segLow = sa(seg);
  var pulgadas = /\b(pulgadas?|inches?|inch|pulg)\b/.test(segLow) || /["\u201d\u2033]/.test(seg);

  // Las unidades se resuelven por numero: "1x1.5 m" son 100x150 cm.
  function aCm(n, despues) {
    if (pulgadas) return Math.round(n * 2.54 * 100) / 100;
    if (/^\s*m\b/.test(despues || '')) return n * 100;      // metros
    if (/^\s*mm\b/.test(despues || '')) return n / 10;      // milimetros
    return n;
  }

  var nums = nlpNumeros(seg);

  // 1) Tamanos con nombre (A4, carta, oficio...). Siempre en cm.
  if (!pulgadas) {
    for (var key in NAMED_SIZES) {
      // Palabra completa: sin esto "A30" se leia como A3 y "A10" como A1.
      var mNom = new RegExp('\\b' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
                            '(?![0-9a-z])').exec(segLow);
      var pos = mNom ? mNom.index : -1;
      if (pos !== -1) {
        var ns = NAMED_SIZES[key];
        var q = null, mejorN = null, sobran = 0;
        // Si ademas hay una medida escrita ("A3+ 50x70"), esos numeros son la
        // medida, no la cantidad: tomarlos pedia 50 laminas.
        var paresNom = nlpPares(seg, nums, aCm);
        var enPar = {};
        for (var pp = 0; pp < paresNom.length; pp++) {
          if (!paresNom[pp].cabe) continue;
          enPar[paresNom[pp].a.i] = true;
          enPar[paresNom[pp].b.i] = true;
        }
        for (var i = 0; i < nums.length; i++) {
          // El 4 de "A4" es parte del nombre, no la cantidad: sin esto,
          // escribir "A4" pedia cuatro laminas y "A3+" tres, en silencio.
          if (nums[i].i >= pos && nums[i].i < pos + key.length) continue;
          if (enPar[nums[i].i]) continue;
          sobran++;
          var pt = nlpPuntaje(nums[i], null);
          if (!mejorN || pt > mejorN.p) mejorN = { n: nums[i], p: pt };
        }
        if (mejorN && mejorN.p >= 0) q = mejorN.n.valor;
        if (q === null) q = nlpCantidadEnPalabras(seg);
        // Sin ningun numero suelto, 1 no es una suposicion: es lo unico que dice
        return { found: true, w: ns.w, h: ns.h, qty: q || 1, sizeId: null,
                 confianza: (q || sobran === 0) ? 'alta' : 'supuesta' };
      }
    }
  }

  // 2) La medida: el par que cabe en la imprenta
  var pares = nlpPares(seg, nums, aCm);
  if (!pares.length) return { found: false };
  var validos = [];
  for (var k = 0; k < pares.length; k++) if (pares[k].cabe) validos.push(pares[k]);
  var medida = validos.length ? validos[0] : pares[0];
  medida.a.usado = medida.b.usado = true;

  // 3) La cantidad: el mejor de los numeros que sobran
  var mejor = null;
  for (var j = 0; j < nums.length; j++) {
    if (nums[j].usado) continue;
    var pj = nlpPuntaje(nums[j], medida);
    if (!mejor || pj > mejor.p) mejor = { n: nums[j], p: pj };
  }
  var enPalabras = nlpCantidadEnPalabras(seg);

  var qty, confianza;
  if (mejor && mejor.p >= 20)      { qty = mejor.n.valor; confianza = 'alta'; }
  else if (enPalabras !== null)    { qty = enPalabras;    confianza = 'alta'; }
  else if (mejor && mejor.p >= 5)  { qty = mejor.n.valor; confianza = 'media'; }
  // Si no sobro ningun numero, "30x40" dice una lamina y nada mas. El aviso se
  // guarda para cuando SI habia otro numero y elegimos ignorarlo, y para cuando
  // el texto dice que son varias sin decir cuantas ("varias copias de 30x40").
  else if (!mejor)                 { qty = 1;
                                     confianza = NLP_VAGO.test(sa(seg)) ? 'supuesta' : 'alta'; }
  else                             { qty = 1;             confianza = 'supuesta'; }

  return { found: true, w: medida.w, h: medida.h, qty: qty, sizeId: null, confianza: confianza };
}

var RE_MEDIDA_SUELTA = /\d+(?:[.,]\d+)?\s*(?:cms?|mm)?\s*x\s*\d+(?:[.,]\d+)?(?:\s*(?:cms?|mm)\b)?(?:\s*[x*]\s*\d{1,4}\b(?!\s*(?:[x*]|[.,]\d)))?/g;
function partirMedidas(s) {
  var cortes = [], m;
  RE_MEDIDA_SUELTA.lastIndex = 0;
  while ((m = RE_MEDIDA_SUELTA.exec(s))) cortes.push(m.index + m[0].length);
  if (cortes.length < 2) return [s];
  var out = [], desde = 0;
  for (var k = 0; k < cortes.length; k++) {
    // Lo que sigue a la ultima medida («en etching», «c/u») se queda con ella
    var hasta = k === cortes.length - 1 ? s.length : cortes[k];
    out.push(s.slice(desde, hasta)); desde = hasta;
  }
  return out;
}

function parseNaturalText(text) {
  var paperId = detectPaper(text);
  var norm = sa(text)
    // Mas abajo el "+" pasa a ser separador de piezas ("30x40 + 50x70"), asi
    // que A3+ hay que salvarlo antes o se lee como A3, que es mas chico. Solo
    // vale pegado: en "A3 + 50x70" el "+" separa dos piezas, y tragarselo
    // convertia el pedido en 50 laminas A3+.
    .replace(/\ba3\+/g, 'a3plus')
    .replace(/\u00d7/g, 'x')
    .replace(/[\r\n]+/g, '|')
    .replace(/\bmas\b|\bmore\b|\bademas\b|\btambien\b/g, '|')
    .replace(/\by\b/g, '|')
    .replace(/(\d),(\d)/g, '$1\u0001$2')
    .replace(/[,;+]/g, '|')
    .replace(/\u0001/g, ',');
  // Varias medidas separadas solo por espacios («40x70 30x40»): cada una es una pieza.
  // Antes el trozo llegaba entero a parseSegment, que se quedaba con una medida y leia
  // el primer numero de la otra como cantidad: «40x70 30x40» salia 30 de 40x70 (26-oct).
  // La cantidad escrita ANTES de una medida queda con ella («2 40x70 3 30x40»), y una
  // escrita pegada despues con x («40x70x3») tambien.
  var segs = [];
  norm.split('|').forEach(function (s) { segs.push.apply(segs, partirMedidas(s)); });
  var results = [], sinLeer = [];

  for (var i = 0; i < segs.length; i++) {
    // Las vinetas y guiones de lista no aportan nada
    var s = String(segs[i]).replace(/^[\s\u2022\u00b7\-*\u2013]+/, '').trim();
    if (!s) continue;

    var r = parseSegment(s);
    if (r && r.found) {
      results.push({ paperId: paperId, w: r.w, h: r.h, qty: r.qty,
                     sizeId: r.sizeId, confianza: r.confianza || 'alta', texto: s });
      continue;
    }

    // Un fragmento con numeros pero sin medida suele ser la cantidad del
    // anterior, separada por una coma: "24x32 cm, cantidad: 40".
    if (/\d/.test(s) && results.length) {
      var ult = results[results.length - 1];
      var r2 = parseSegment(ult.texto + ' ' + s);
      if (r2 && r2.found && r2.w === ult.w && r2.h === ult.h && r2.qty > ult.qty) {
        ult.qty = r2.qty;
        ult.confianza = r2.confianza || ult.confianza;
        continue;
      }
    }

    // Si tiene numeros y no se entendio, se guarda para poder avisarlo
    if (/\d/.test(s)) sinLeer.push(s);
  }
  return { paperId: paperId, items: results, sinLeer: sinLeer,
    // Si es false, el papel es el valor por omision y no algo que se escribio
    paperExplicito: papelDelTexto(text) !== null };
}

var ITEM_COLORS = ['#4f86c6','#e06c6c','#5bb55f','#d4944a','#9775c8','#3fa0a0','#c7776a','#7aad58','#c47db8','#7b8fc9'];

function buildSVG(rollWidth, totalLength, pack, svgW, sugerencias) {
  svgW = svgW || 280;
  if (!totalLength || totalLength <= 0) return '';

  // Margenes para que las cotas queden FUERA del rollo, no encima de las piezas.
  var GI = 36, GS = 24, GD = 8, GB = 10;   // izquierda, arriba, derecha, abajo
  var ancho = svgW - GI - GD;
  var scale = ancho / rollWidth;
  var alto = Math.round(totalLength * scale);
  var svgH = alto + GS + GB;

  var MONO = 'ui-monospace,SFMono-Regular,Consolas,monospace';
  var TINTA = 'var(--cqc-suave-2)';

  // Cada estrategia devuelve el acomodo con una forma distinta: maxrects entrega la
  // lista de posiciones directamente en shelves; las de estanteria las agrupan en
  // sh.items; y la de columnas (traida del cotizador original) usa sh.placements.
  // Aceptamos las tres: antes, con un acomodo por columnas, esto reventaba.
  var items = [];
  (pack.shelves || []).forEach(function(sh) {
    if (!sh) return;
    if (sh.w !== undefined && sh.x !== undefined) { items.push(sh); return; }
    var lista = sh.placements || sh.items;
    if (lista && lista.forEach) lista.forEach(function(p) { items.push(p); });
  });

  // ── Hasta diez metros ─────────────────────────────────────────────
  // Mas alla el dibujo no aporta: son las mismas filas repetidas, y a 5000
  // piezas serian 10.000 elementos y 18.000 px de alto.
  var TOPE_CM = 1000, SALTO_PX = 34;
  var plegado = null;
  if (totalLength > TOPE_CM * 1.05) {
    plegado = { desde: TOPE_CM, resto: totalLength - TOPE_CM };
    // Cuantas filas quedan fuera, para poder decirlo
    var ysFuera = {}, nFuera = 0;
    items.forEach(function(p) {
      if (p.y < TOPE_CM) return;
      var k = Math.round(p.y * 100) / 100;
      if (!ysFuera[k]) { ysFuera[k] = 1; nFuera++; }
    });
    plegado.filas = nFuera;
    items = items.filter(function(p) { return p.y < TOPE_CM; });
  }

  // De centimetros a la altura dibujada
  function aY(cm) {
    if (!plegado || cm <= plegado.desde) return cm * scale;
    return plegado.desde * scale + SALTO_PX;
  }
  alto = Math.round(aY(totalLength));
  svgH = alto + GS + GB;

  // Los huecos, punteados y por encima de las piezas
  var svgSug = '';
  (sugerencias || []).forEach(function(f) {
    var sx = Math.round(f.x * scale) + 1, sy = Math.round(aY(f.y)) + 1;
    var sw = Math.max(2, Math.round(f.w * scale) - 2), sh = Math.max(2, Math.round(f.h * scale) - 2);
    svgSug += '<rect x="' + sx + '" y="' + sy + '" width="' + sw + '" height="' + sh + '" ' +
      'fill="var(--cqc-tarjeta)" fill-opacity="0.9" stroke="var(--cqc-acento)" ' +
      'stroke-width="1.5" stroke-dasharray="4,3" rx="2"/>';
    if (sw > 26 && sh > 14) {
      var fs = Math.min(11, Math.max(8, Math.round(Math.min(sw, sh) * 0.2)));
      svgSug += '<text x="' + (sx + sw / 2) + '" y="' + (sy + sh / 2) + '" text-anchor="middle" ' +
        'dominant-baseline="middle" font-size="' + fs + '" fill="var(--cqc-acento)" ' +
        'font-family="' + MONO + '" font-weight="700">' + f.w + '\u00d7' + f.h + '</text>';
    }
  });

  var piezas = items.map(function(p) {
    var x = Math.round(p.x * scale);
    var y = Math.round(aY(p.y));
    var w = Math.max(1, Math.round(p.w * scale) - 1);
    var h = Math.max(1, Math.round(p.h * scale) - 1);
    var color = p.color || '#4f86c6';
    var label = p.label || '';
    // 1 unidad del SVG = 1 pixel en pantalla, asi que este tamano es el real
    // 9 px es el piso: por debajo la medida deja de leerse en un telefono.
    var fs = Math.max(9, Math.min(13, Math.round(Math.min(w, h) / 3)));
    var cabe = (w > label.length * fs * 0.62) && h > fs * 1.7;
    // Dos capas: una base opaca que tapa el fondo del rollo, y encima el tinte
    // del color de la medida. Sin la base, la trama del papel se cuela por dentro
    // de la pieza y todo el dibujo se lee como rayas.
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h +
      '" fill="var(--cqc-tarjeta)" rx="2"/>' +
      '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h +
      '" fill="' + color + '" fill-opacity="0.17" stroke="' + color + '" stroke-width="1.3" rx="2"/>' +
      (cabe ? '<text x="' + (x + w/2) + '" y="' + (y + h/2) + '" text-anchor="middle" dominant-baseline="middle" ' +
        'font-family="' + MONO + '" font-size="' + fs + '" font-weight="700" fill="' + color + '" ' +
        'paint-order="stroke" stroke="var(--cqc-tarjeta)" stroke-width="2.5" stroke-linejoin="round">' +
        label + '</text>' : '');
  }).join('');

  // La banda del corte, con lo que queda fuera del dibujo
  var svgCorte = '';
  if (plegado) {
    var yc1 = Math.round(plegado.desde * scale);
    var metros = (plegado.resto / 100).toFixed(plegado.resto >= 1000 ? 0 : 1).replace('.', ',');
    var texto = plegado.filas + ' filas m\u00e1s \u00b7 ' + metros + ' m de rollo';
    svgCorte =
      '<rect x="-2" y="' + yc1 + '" width="' + (ancho + 4) + '" height="' + SALTO_PX +
      '" fill="var(--cqc-tarjeta)"/>' +
      '<line x1="0" y1="' + (yc1 + 5) + '" x2="' + ancho + '" y2="' + (yc1 + 5) +
      '" stroke="var(--cqc-borde)" stroke-width="1" stroke-dasharray="5,4"/>' +
      '<line x1="0" y1="' + (yc1 + SALTO_PX - 5) + '" x2="' + ancho + '" y2="' + (yc1 + SALTO_PX - 5) +
      '" stroke="var(--cqc-borde)" stroke-width="1" stroke-dasharray="5,4"/>' +
      '<text x="' + (ancho / 2) + '" y="' + (yc1 + SALTO_PX / 2 + 3) + '" text-anchor="middle" ' +
      'font-family="' + MONO + '" font-size="9.5" font-weight="700" fill="' + TINTA + '" ' +
      'paint-order="stroke" stroke="var(--cqc-tarjeta)" stroke-width="3" stroke-linejoin="round">' +
      texto + '</text>';
  }

  // ── Regla en centimetros, al costado ──────────────────────────────
  // El paso se elige segun lo que se DIBUJA, no segun el total: con el dibujo
  // cortado en 10 m, marcas cada 500 dejarian dos rayitas.
  var largoRegla = plegado ? plegado.desde : totalLength;
  var pasos = [5, 10, 20, 25, 50, 100, 200, 500], paso = pasos[pasos.length - 1];
  for (var i = 0; i < pasos.length; i++) {
    if (largoRegla / pasos[i] <= 12) { paso = pasos[i]; break; }
  }
  var regla = '<line x1="' + (GI - 1) + '" y1="' + GS + '" x2="' + (GI - 1) + '" y2="' + (GS + alto) +
    '" stroke="' + TINTA + '" stroke-width="1" opacity=".55"/>';
  // Se salta la ultima marca si va a chocar con el total.
  var corte = largoRegla - paso * 0.45;
  for (var cm = 0; cm <= corte; cm += paso) {
    var y = GS + Math.round(aY(cm));
    regla += '<line x1="' + (GI - 6) + '" y1="' + y + '" x2="' + (GI - 1) + '" y2="' + y +
      '" stroke="' + TINTA + '" stroke-width="1" opacity=".5"/>' +
      '<text x="' + (GI - 9) + '" y="' + (y + 3) + '" text-anchor="end" font-family="' + MONO +
      '" font-size="8.5" fill="' + TINTA + '" opacity=".75">' + cm + '</text>';
  }
  // El total, marcado mas fuerte: es el numero por el que se paga.
  var yFin = GS + alto;
  regla += '<line x1="' + (GI - 8) + '" y1="' + yFin + '" x2="' + (GI - 1) + '" y2="' + yFin +
    '" stroke="' + TINTA + '" stroke-width="1.4" opacity=".9"/>' +
    '<text x="' + (GI - 11) + '" y="' + (yFin + 3) + '" text-anchor="end" font-family="' + MONO +
    '" font-size="9.5" font-weight="700" fill="' + TINTA + '">' + Math.ceil(totalLength) + '</text>';

  // ── Cota del ancho, arriba y fuera del rollo ──────────────────────
  var yc = GS - 11;
  var cota = '<line x1="' + GI + '" y1="' + yc + '" x2="' + (GI + ancho) + '" y2="' + yc +
    '" stroke="' + TINTA + '" stroke-width="1" opacity=".55"/>' +
    '<line x1="' + GI + '" y1="' + (yc - 3.5) + '" x2="' + GI + '" y2="' + (yc + 3.5) +
    '" stroke="' + TINTA + '" stroke-width="1" opacity=".55"/>' +
    '<line x1="' + (GI + ancho) + '" y1="' + (yc - 3.5) + '" x2="' + (GI + ancho) + '" y2="' + (yc + 3.5) +
    '" stroke="' + TINTA + '" stroke-width="1" opacity=".55"/>' +
    '<rect x="' + (GI + ancho/2 - 21) + '" y="' + (yc - 7) + '" width="42" height="14" ' +
    'fill="var(--cqc-tarjeta)"/>' +
    '<text x="' + (GI + ancho/2) + '" y="' + (yc + 3.5) + '" text-anchor="middle" font-family="' + MONO +
    '" font-size="9.5" font-weight="700" fill="' + TINTA + '">' + rollWidth + ' cm</text>';


  // El rollo: fondo rayado para que se lea que lo blanco es papel sin usar.
  // El papel sin usar va en un tono plano y suave. Con trama competia con las
  // piezas y en el telefono se comia el dibujo entero.
  var rollo = '<rect x="' + GI + '" y="' + GS + '" width="' + ancho + '" height="' + alto +
    '" fill="var(--cqc-fondo)" stroke="var(--cqc-borde)" stroke-width="1.3" rx="3"/>';


  return '<svg width="' + svgW + '" height="' + svgH + '" viewBox="0 0 ' + svgW + ' ' + svgH +
    '" style="width:100%;height:auto;overflow:visible;" role="img" aria-label="El pedido acomodado en un rollo de ' +
    rollWidth + ' por ' + Math.ceil(totalLength) + ' centímetros">' +
    rollo + cota + regla +
    '<g class="cn-piezas" transform="translate(' + GI + ',' + GS + ')">' +
    piezas + svgCorte + svgSug + '</g></svg>';
}

  // ── Tarifa por volumen (19-oct-2026) ──────────────────────────────────────
  // Smooth + Satin + Photo Luster, sumados: desde $1.000.000 → 15%, desde $1.500.000 → 20%,
  // desde $2.000.000 → 25%. Se descuenta solo sobre esos tres papeles. `partes` = [{paper, price}].
  // 29-oct-2026: APAGADO por decisión del dueño («desactiva todo descuento por volumen… lo
  // reactivaré más adelante»). Los tramos y papeles quedan tal cual; para encenderlo, activo: true.
  var VOLUMEN = { activo: false, papeles: ['fs-smooth', 'fs-satin', 'hn-luster'],
                  tramos: [{ desde: 1000000, pct: 15 }, { desde: 1500000, pct: 20 }, { desde: 2000000, pct: 25 }] };
  function tarifaVolumen(partes) {
    var suma = 0, otros = 0;
    (partes || []).forEach(function (p) {
      if (VOLUMEN.papeles.indexOf(p.paper) >= 0) suma += (p.price || 0); else otros += (p.price || 0);
    });
    // Apagado: 0%, sin «siguiente» tramo y con mínimo inalcanzable, para que el cotizador no
    // descuente ni muestre «te faltan $X para la tarifa por volumen».
    if (!VOLUMEN.activo) return { suma: suma, otros: otros, pct: 0, descuento: 0, siguiente: null, minimo: Infinity, activo: false };
    var pct = 0, sig = null;
    VOLUMEN.tramos.forEach(function (t) { if (suma >= t.desde) pct = t.pct; });
    for (var i = 0; i < VOLUMEN.tramos.length; i++) {
      if (suma < VOLUMEN.tramos[i].desde) { sig = { pct: VOLUMEN.tramos[i].pct, falta: VOLUMEN.tramos[i].desde - suma }; break; }
    }
    return { suma: suma, otros: otros, pct: pct, descuento: Math.round(suma * pct / 100), siguiente: sig, minimo: VOLUMEN.tramos[0].desde };
  }

  // ── El mínimo de compra dicho como lo entiende el cliente (25-oct-2026) ──────
  // La regla real es una sola: cada papel se imprime desde un largo mínimo de
  // rollo (60×40 en el de 60). Antes cada medida decía «mín 4», «mín 2» y, al
  // combinar medidas, eso no regía. Estas funciones la traducen a pesos y a
  // opciones concretas para el cliente; no cambian ningún precio.
  var MEDIDAS_INICIO = [[20, 30], [30, 40], [60, 40]];
  // Las que más se piden: las sugerencias para completar salen solo de aquí.
  var MEDIDAS_PEDIDAS = [[30, 40], [60, 40], [20, 30], [50, 70]];
  function _menorQueAlcanza(w, h, base, paperId) {
    for (var q = 1; q <= 12; q++) {
      var o = calculateOrder((base || []).concat([{ qty: q, w: w, h: h }]), paperId);
      if (o && !o.winner.belowMin) return { qty: q, precio: Math.round(o.winner.price) };
    }
    return null;
  }
  // Las tres maneras de empezar ya comprables: [{w, h, qty, precio}].
  function opcionesInicio(paperId) {
    return MEDIDAS_INICIO.map(function (m) {
      var r = _menorQueAlcanza(m[0], m[1], [], paperId);
      return r ? { w: m[0], h: m[1], qty: r.qty, precio: r.precio } : null;
    }).filter(Boolean);
  }
  // El monto desde el que se puede comprar ese papel.
  function minimoPapel(paperId) {
    var ops = opcionesInicio(paperId);
    return ops.length ? Math.min.apply(null, ops.map(function (o) { return o.precio; })) : null;
  }
  // Qué agregar para llegar al mínimo: [{agregar: [{qty, w, h}], precio, piezas}], a lo más dos.
  // 27-oct-2026: primero la más barata entre «más de la misma medida» (la última que se pidió) y las
  // combinaciones de medidas que se piden; si cuestan lo mismo, la misma medida. Después, completar
  // con 30×40 (la más pedida), si es otra. A igual precio gana la que deja más impresiones: antes
  // ganaba la de menos y a quien pedía 1 de 20×30 se le ofrecía 3 impresiones por $16.490 en vez
  // de 4. `piezas` = impresiones que recibe en total. Vacío si ya alcanza.
  var _sugCache = {};
  function sugerirMinimo(items, paperId) {
    var base = (items || []).filter(function (it) { return it.w > 0 && it.h > 0 && it.qty >= 1; })
      .map(function (it) { return { qty: it.qty, w: it.w, h: it.h }; });
    var clave = paperId + '|' + (_god ? 'g' : '') + _min60 + '|' + JSON.stringify(base);
    if (_sugCache[clave]) return _sugCache[clave];
    var out = [], o0 = calculateOrder(base, paperId);
    if (o0 && o0.winner.belowMin) {
      var n0 = base.reduce(function (s, x) { return s + x.qty; }, 0);
      var opcion = function (agregar) {
        var o = calculateOrder(base.concat(agregar), paperId);
        if (!o || o.winner.belowMin) return null;
        return { agregar: agregar, precio: Math.round(o.winner.price), piezas: n0 + agregar.reduce(function (s, x) { return s + x.qty; }, 0) };
      };
      var completar = function (w, h) {
        for (var q = 1; q <= 12; q++) { var r = opcion([{ qty: q, w: w, h: h }]); if (r) return r; }
        return null;
      };
      var ult = base[base.length - 1];
      var misma = ult ? completar(ult.w, ult.h) : null;
      var de30x40 = completar(30, 40);
      var mejor = null;
      MEDIDAS_PEDIDAS.forEach(function (m, i) {
        var cands = [];
        for (var q = 1; q <= 6; q++) cands.push([{ qty: q, w: m[0], h: m[1] }]);
        MEDIDAS_PEDIDAS.slice(i + 1).forEach(function (n) {
          for (var q1 = 1; q1 <= 3; q1++) for (var q2 = 1; q2 <= 3; q2++) cands.push([{ qty: q1, w: m[0], h: m[1] }, { qty: q2, w: n[0], h: n[1] }]);
        });
        cands.forEach(function (c) {
          var r = opcion(c);
          if (r && (!mejor || r.precio < mejor.precio || (r.precio === mejor.precio && r.piezas > mejor.piezas))) mejor = r;
        });
      });
      var igual = function (a, b) { return JSON.stringify(a.agregar) === JSON.stringify(b.agregar); };
      var primera = (misma && (!mejor || misma.precio <= mejor.precio)) ? misma : (mejor || misma);
      if (primera) out.push(primera);
      [de30x40, misma, mejor].forEach(function (x) {
        if (out.length < 2 && x && !out.some(function (y) { return igual(x, y); })) out.push(x);
      });
    }
    _sugCache[clave] = out;
    return out;
  }
  // El nombre corto de una medida: «A4», «20×30» (la del catálogo si es una; si no, sus lados).
  function nombreMedida(w, h) {
    for (var i = 0; i < SIZES.length; i++) {
      var s = SIZES[i];
      if ((s.w === w && s.h === h) || (s.w === h && s.h === w)) return s.label.replace(/ cm$/, '');
    }
    return w + '×' + h;
  }
  // «2 de 30×40» / «1 de 30×40 y 1 de 20×30»
  function textoAgregar(lista) {
    return (lista || []).map(function (x) { return x.qty + ' de ' + nombreMedida(x.w, x.h); }).join(' y ');
  }
  // El mínimo dicho como TAMAÑO de papel, no como monto (27-oct-2026, pedido del dueño): el cliente
  // entiende mejor «60×40 cm de papel» que un precio. `w` = winner de calculateOrder bajo el mínimo.
  function textoMinimo(w) {
    if (!w) return '';
    return 'Mínimo de impresión: ' + w.rollW + '×' + w.minRollLen + ' cm de papel. Tu pedido ocupa ' +
      w.rollW + '×' + Math.ceil(w.realLength) + ' cm.';
  }
  // Cuánto agrega un botón de medida (29-oct-2026): si el pedido —contando lo que ya tiene— no
  // llega al mínimo de impresión, las justas de esa medida para llegar; si ya llega, una. Así el
  // primer toque queda comprable (vacío + 30×40 = 2) y nunca agrega de más (60×30 + 20×30 = 1).
  // Devuelve {qty, nota}; `nota` explica por qué se agregó más de una (vacía si es una).
  function botonMedida(items, w, h, paperId) {
    var base = (items || []).filter(function (it) { return it.w > 0 && it.h > 0 && it.qty >= 1; })
      .map(function (it) { return { qty: it.qty, w: it.w, h: it.h }; });
    if (base.length) { var o0 = calculateOrder(base, paperId); if (!o0 || !o0.winner.belowMin) return { qty: 1, nota: '' }; }
    var r = _menorQueAlcanza(w, h, base, paperId);
    if (!r || r.qty <= 1) return { qty: 1, nota: '' };
    var o = calculateOrder(base.concat([{ qty: r.qty, w: w, h: h }]), paperId);
    // El tamaño solo en el rollo de 60 (el que se muestra en todo el sitio: «60×40»); si el pedido
    // va al de 110, decir «110×20» confundiría.
    var minimo = (o && o.winner.rollW === 60) ? ' (' + o.winner.rollW + '×' + o.winner.minRollLen + ' cm de papel)' : '';
    return { qty: r.qty, nota: 'Agregamos ' + r.qty + ' de ' + nombreMedida(w, h) + ' para llegar al mínimo de impresión' +
      minimo + '. Pueden ser imágenes distintas.' };
  }
  // Para la barra de precio mientras no se llega al mínimo: «Mín. 60×40 cm».
  function rotuloMinimo(w) { return w ? 'Mín. ' + w.rollW + '×' + w.minRollLen + ' cm' : ''; }

  global.CotizadorEngine = {
    PAPERS: PAPERS,
    PRICES_60: PRICES_60,
    PRICES_110: PRICES_110,
    SIZES: SIZES,
    PAPER_NLP: PAPER_NLP,
    PAPEL_CLAVES: PAPEL_CLAVES,
    WORD_NUMS: WORD_NUMS,
    NLP_CANT: NLP_CANT,
    NLP_UNIDAD: NLP_UNIDAD,
    NLP_PAPEL: NLP_PAPEL,
    NLP_MES: NLP_MES,
    NLP_RUIDO: NLP_RUIDO,
    NLP_TECNICO: NLP_TECNICO,
    NLP_CONTEXTO: NLP_CONTEXTO,
    NLP_VAGO: NLP_VAGO,
    NAMED_SIZES: NAMED_SIZES,
    interpolatePrice: interpolatePrice,
    ptLengthForRoll: ptLengthForRoll,
    ptLengthForQty: ptLengthForQty,
    ptPriceForSize: ptPriceForSize,
    preOptimizeRotations: preOptimizeRotations,
    packShelfOnce: packShelfOnce,
    _packMaxRectsOnce: _packMaxRectsOnce,
    packMaxRects: packMaxRects,
    packShelfFixed: packShelfFixed,
    packBruteOrientations: packBruteOrientations,
    _mrSueltasOnce: _mrSueltasOnce,
    mrSueltas: mrSueltas,
    packBrutaPorPieza: packBrutaPorPieza,
    packByColumns: packByColumns,
    packColumnasParejas: packColumnasParejas,
    packLocalSearch: packLocalSearch,
    packPerfectRows: packPerfectRows,
    packFranjas: packFranjas,
    packShelf: packShelf,
    packCacheado: packCacheado,
    piezasDelPack: piezasDelPack,
    huecosLibres: huecosLibres,
    sugerenciasSobrante: sugerenciasSobrante,
    sobrantesQueNoCuestan: sobrantesQueNoCuestan,
    calculateOrder: calculateOrder,
    getPaper: getPaper,
    getSize: getSize,
    fmtCLP: fmtCLP,
    sa: sa,
    stripAccents: stripAccents,
    detectPaper: detectPaper,
    papelDelTexto: papelDelTexto,
    extractQty: extractQty,
    rawSize: rawSize,
    nlpNumeros: nlpNumeros,
    nlpPares: nlpPares,
    nlpPuntaje: nlpPuntaje,
    nlpCantidadEnPalabras: nlpCantidadEnPalabras,
    parseSegment: parseSegment,
    parseNaturalText: parseNaturalText,
    ITEM_COLORS: ITEM_COLORS,
    buildSVG: buildSVG,
    TABLE_MIN: TABLE_MIN,
    TABLE_MAX: TABLE_MAX,
    TABLE_STEP: TABLE_STEP,
    MIN60_NORMAL: MIN60_NORMAL,
    MIN60_CHICO: MIN60_CHICO,
    MAX_QTY: MAX_QTY,

    // El minimo del rollo de 60 se rebaja con control+clic en el precio, y el
    // rollo se puede forzar con control+clic en la insignia. Van por funcion
    // porque son estado del motor.
    getMin60: function () { return _min60; },
    setMin60: function (n) { _min60 = n; },
    getForcedRoll: function () { return _forcedRoll; },
    setForcedRoll: function (r) { _forcedRoll = r; },
    tarifaVolumen: tarifaVolumen,
    opcionesInicio: opcionesInicio,
    minimoPapel: minimoPapel,
    sugerirMinimo: sugerirMinimo,
    textoAgregar: textoAgregar,
    textoMinimo: textoMinimo,
    rotuloMinimo: rotuloMinimo,
    botonMedida: botonMedida,
    nombreMedida: nombreMedida,
    VOLUMEN: VOLUMEN,
    isGod: function () { return _god; },
    ladoMin: ladoMin,
    setGod: setGod,
    resetCache: function () { _packCache = {}; _packOrden = []; }
  };
  // Cualquier caja de texto: escribir GODMODE alterna el modo y la palabra se
    // borra del campo. Los cotizadores se enteran por el evento 'lt-god'.
    if (typeof document !== 'undefined' && !global.__ltGodListener) {
      global.__ltGodListener = true;
      document.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || typeof t.value !== 'string' || !/godmode/i.test(t.value)) return;
        t.value = t.value.replace(/godmode/ig, '').replace(/\s{2,}/g, ' ').trim();
        setGod(!_god);
        t.dispatchEvent(new Event('input', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('lt-god', { detail: { activo: _god } }));
      }, true);
    }
})(typeof window !== 'undefined' ? window : globalThis);
